// Từ điển song ngữ cho landing site (`/`).
// Key dạng dot-notation. VI là ngôn ngữ mặc định.
// Khi thêm chuỗi mới: thêm cả 2 ngôn ngữ để giữ parity.
// Các key khu admin (/admin) tách theo feature ở ./admin và merge ở cuối file.
import adminDictionary from './admin';

const dictionary = {
  vi: {
    'header.nav.platforms': 'Nền tảng',
    'header.nav.features': 'Tính năng',
    'header.nav.howItWorks': 'Cách hoạt động',
    'header.nav.contact': 'Liên hệ',
    'header.nav.legal': 'Pháp lý',
    'header.cta.signIn': 'Đăng nhập',
    'header.cta.dashboard': 'Vào Dashboard',
    'header.lang.label': 'Ngôn ngữ',
    'header.lang.vi': 'Tiếng Việt',
    'header.lang.en': 'English',

    'hero.badge': 'Social Posting Control · 8 Nền tảng',
    'hero.title.line1': 'Một dashboard, đăng bài lên',
    'hero.title.line2': 'mọi mạng xã hội.',
    'hero.subtitle':
      'Kết nối Facebook, Instagram, Threads, YouTube, X, Pinterest, TikTok và Telegraph. Tạo nội dung, lên lịch và theo dõi — tất cả ở một nơi.',
    'hero.cta.signIn': 'Đăng nhập',
    'hero.cta.dashboard': 'Vào Dashboard',
    'hero.trust': 'Được tin dùng bởi đội ngũ nội dung quản lý tài khoản trên 8 mạng xã hội',

    'platforms.badge': 'NỀN TẢNG HỖ TRỢ',
    'platforms.title': '8 mạng xã hội, sẵn sàng kết nối',
    'platforms.subtitle':
      'Tích hợp OAuth chính thức với mọi nền tảng — không lưu mật khẩu, không cần plugin trình duyệt.',
    'platforms.live': 'LIVE',
    'platforms.viewAll': 'Xem tất cả tích hợp',
    'platform.tiktok.tagline': 'Đăng video ngắn',
    'platform.facebook.tagline': 'Đăng & lên lịch bài Page',
    'platform.instagram.tagline': 'Bài Feed, Carousel, Reels',

    // Messenger inbox (admin)
    'messenger.title': 'Hộp thư Messenger',
    'messenger.selectPage': 'Chọn Trang',
    'messenger.noPages': 'Chưa có Trang nào',
    'messenger.managePages': 'Quản lý Trang',
    'messenger.you': 'Bạn',
    'messenger.empty.connectPrompt':
      'Chưa có Trang nào bật Messenger. Bấm "Quản lý Trang" để chọn Trang Facebook và bật trả lời tin nhắn.',
    'messenger.empty.noConversations': 'Chưa có hội thoại nào.',
    'messenger.thread.selectPrompt': 'Chọn một hội thoại để xem và trả lời tin nhắn.',
    'messenger.reply.placeholder': 'Nhập tin trả lời… (Enter để gửi)',
    'messenger.reply.send': 'Gửi',
    'messenger.reply.failed': 'Gửi thất bại',
    'messenger.pages.title': 'Quản lý Trang Messenger',
    'messenger.pages.description':
      'Bật Messenger cho từng Trang để nhận và trả lời tin nhắn ngay trong hộp thư.',
    'messenger.pages.account': 'Tài khoản Facebook',
    'messenger.pages.selectAccount': 'Chọn tài khoản',
    'messenger.pages.noPages': 'Tài khoản này không quản trị Trang nào.',
    'messenger.pages.enable': 'Bật',
    'messenger.pages.disconnect': 'Ngắt',
    'messenger.pages.close': 'Đóng',
    'messenger.pages.loadFailed': 'Không tải được danh sách Trang',
    'messenger.pages.subscribed': 'Đã bật Messenger cho {name}',
    'messenger.pages.unsubscribed': 'Đã tắt Messenger cho {name}',
    'messenger.pages.subscribeFailed': 'Bật Messenger thất bại',
    'messenger.pages.unsubscribeFailed': 'Tắt Messenger thất bại',
    'messenger.clearHistory': 'Xóa lịch sử',
    'messenger.delete.title': 'Xóa hội thoại',
    'messenger.delete.desc':
      'Xóa hội thoại này khỏi hộp thư? Chỉ xóa bản lưu trong hệ thống, không ảnh hưởng tới Messenger của người dùng. Nếu họ nhắn tiếp, hội thoại sẽ xuất hiện lại.',
    'messenger.delete.confirm': 'Xóa',
    'messenger.delete.success': 'Đã xóa hội thoại',
    'messenger.delete.failed': 'Xóa hội thoại thất bại',
    'messenger.clear.title': 'Xóa toàn bộ lịch sử',
    'messenger.clear.desc':
      'Xóa toàn bộ hội thoại và tin nhắn đã lưu của Trang này? Chỉ xóa bản lưu trong hệ thống, không ảnh hưởng tới Messenger của người dùng. Hành động này không thể hoàn tác.',
    'messenger.clear.confirm': 'Xóa tất cả',
    'messenger.clear.success': 'Đã xóa toàn bộ lịch sử',
    'messenger.clear.failed': 'Xóa lịch sử thất bại',

    // Facebook account form (admin) — login flow cho pages_messaging
    'fbForm.title.create': 'Tạo tài khoản Facebook',
    'fbForm.title.update': 'Cập nhật tài khoản Facebook',
    'fbForm.login': 'Đăng nhập Facebook',
    'fbForm.loginAgain': 'Đăng nhập lại Facebook',
    'fbForm.gotInfo': 'Đã lấy thông tin từ Facebook',
    'fbForm.currentAvatar': 'Ảnh đại diện hiện tại',
    'fbForm.field.name': 'Tên',
    'fbForm.field.userId': 'User ID',
    'fbForm.field.picture': 'Ảnh đại diện (URL)',
    'fbForm.field.active': 'Kích hoạt',
    'fbForm.cancel': 'Hủy',
    'fbForm.create': 'Tạo',
    'fbForm.update': 'Cập nhật',
    'fbForm.toast.missingClientId': 'Thiếu cấu hình REACT_APP_FACEBOOK_CLIENT_ID.',
    'fbForm.toast.invalidState': 'State OAuth không hợp lệ, vui lòng đăng nhập lại.',
    'fbForm.toast.loginDenied': 'Facebook từ chối đăng nhập: {reason}',
    'fbForm.toast.needLogin': 'Bạn cần đăng nhập Facebook trước khi tạo tài khoản.',
    'fbForm.toast.createSuccess': 'Tạo tài khoản thành công.',
    'fbForm.toast.createFailed': 'Tạo tài khoản thất bại.',
    'fbForm.toast.updateSuccess': 'Cập nhật tài khoản thành công.',
    'fbForm.toast.updateFailed': 'Cập nhật tài khoản thất bại.',

    'platform.threads.tagline': 'Đăng Threads qua Meta API',
    'platform.youtube.tagline': 'Tải video & metadata',
    'platform.x-twitter.tagline': 'Lên lịch tweet & threads',
    'platform.pinterest.tagline': 'Quản lý Pin & board',
    'platform.telegraph.tagline': 'Đăng bài viết dài',

    'tiktok.badge': 'TÍCH HỢP TIKTOK',
    'tiktok.title': 'Luồng TikTok hoàn chỉnh, từ đầu đến cuối',
    'tiktok.subtitle':
      'Xây dựng trên Login Kit, Content Posting API và Display API của TikTok. Mọi màn hình đều tuân thủ Content Sharing Guidelines và Branded Content Policy của TikTok.',
    'tiktok.shot1.title': 'Kết nối qua TikTok OAuth',
    'tiktok.shot1.desc':
      'Người dùng cấp quyền qua màn hình consent chính thức của TikTok bằng Login Kit (user.info.basic, user.info.profile). Client secret luôn ở phía server.',
    'tiktok.shot2.title': 'Khu vực tài khoản đã kết nối',
    'tiktok.shot2.desc':
      'Toàn bộ tài khoản TikTok đã kết nối trong một dashboard, có toggle trạng thái, link nhanh tới profile TikTok và thao tác theo từng tài khoản.',
    'tiktok.shot3.title': 'Chi tiết tài khoản & đồng bộ',
    'tiktok.shot3.desc':
      'Dữ liệu profile lấy từ TikTok — tên hiển thị, username, avatar, bio — kèm nút re-sync và bộ đếm bài đăng 24h.',
    'tiktok.shot4.title': 'Duyệt video qua Display API',
    'tiktok.shot4.desc':
      'Thư viện video chỉ đọc dùng scope video.list — cover, tiêu đề, lượt xem/like/comment/share, phân trang cursor.',
    'tiktok.shot5.title': 'Soạn bài với creator_info gating',
    'tiktok.shot5.desc':
      'Trình soạn bài tuân theo creator_info: mức privacy được phép, độ dài video tối đa, khoá comment/duet/stitch theo tài khoản và disclosure Branded Content.',
    'tiktok.shot6.title': 'Đăng bài qua Content Posting API',
    'tiktok.shot6.desc':
      'video.upload + video.publish — bài đăng lên TikTok và share_url trả về được lưu để đối soát.',
    'tiktok.note.encrypted': 'Token OAuth được mã hoá (AES-256-GCM)',
    'tiktok.note.serverSecret': 'client_secret ở server-side',
    'tiktok.note.creatorInfo': 'Tuân thủ creator_info ở mọi lần publish',

    // Compliance disclosure trên form đăng bài (bắt buộc theo TikTok Direct
    // Post Developer Guidelines). Lead + trailing tách ra để chèn link inline.
    'tiktok.compliance.lead': 'Bằng việc đăng, bạn đồng ý với',
    'tiktok.compliance.trailing': ' của TikTok.',
    'tiktok.compliance.and': 'và',
    'tiktok.compliance.musicLink': 'Music Usage Confirmation',
    'tiktok.compliance.brandedLink': 'Branded Content Policy',
    'tiktok.compliance.brandedNoPrivate':
      'Branded content (paid partnership) không thể đăng ở chế độ Riêng tư (Chỉ mình tôi). Hãy chọn chế độ hiển thị công khai hơn.',
    // Composer — privacy (no default), interaction (allow-framing), commercial.
    'tiktok.privacy.placeholder': 'Chọn ai có thể xem nội dung này',
    'tiktok.privacy.required': 'Vui lòng chọn chế độ hiển thị (privacy).',
    'tiktok.privacy.brandedNoPrivateTip':
      'Branded content không thể đặt ở chế độ riêng tư (Chỉ mình tôi).',
    'tiktok.interaction.title': 'Cho phép người xem',
    'tiktok.interaction.comment': 'Bình luận',
    'tiktok.interaction.duet': 'Duet',
    'tiktok.interaction.stitch': 'Stitch',
    'tiktok.interaction.accountOff': '(tài khoản đã tắt)',
    'tiktok.commercial.master':
      'Cho biết nội dung này có quảng bá bản thân, một thương hiệu, sản phẩm hoặc dịch vụ',
    'tiktok.commercial.masterHint': 'Bật nếu bài đăng có nội dung quảng cáo.',
    'tiktok.commercial.yourBrand': 'Thương hiệu của bạn',
    'tiktok.commercial.yourBrandLabel': 'Video/ảnh của bạn sẽ được gắn nhãn “Promotional content”.',
    'tiktok.commercial.brandedContent': 'Nội dung có thương hiệu',
    'tiktok.commercial.brandedContentLabel':
      'Video/ảnh của bạn sẽ được gắn nhãn “Paid partnership”.',
    'tiktok.commercial.required':
      'Bạn cần cho biết nội dung quảng bá bản thân, bên thứ ba, hay cả hai.',
    'tiktok.commercial.musicLibraryNote':
      'Nhạc trong Branded Content phải nằm trong TikTok Commercial Music Library.',

    // ===== Admin · TikTok post form (Tạo/Sửa bài) =====
    'tiktok.form.defaultName': 'Tên hiển thị',
    'tiktok.form.captionPlaceholder': 'Nội dung mô tả sẽ hiển thị ở đây...',
    'tiktok.form.previewUpload': 'Upload video/ảnh để xem preview',
    'tiktok.form.defaultPrivacy': 'Riêng tư',
    'tiktok.privacyOption.public': 'Công khai',
    'tiktok.privacyOption.mutual': 'Bạn bè (follow nhau)',
    'tiktok.privacyOption.follower': 'Người theo dõi',
    'tiktok.privacyOption.selfOnly': 'Riêng tư (chỉ mình tôi)',
    'tiktok.form.privacyDisallowed':
      '⚠ Tài khoản này chỉ được phép: {list}. BE sẽ reject privacy khác.',
    'tiktok.form.status.published': '✓ Đã đăng',
    'tiktok.form.status.failed': '⚠ Lỗi',
    'tiktok.form.status.scheduled': '📅 Đã lên lịch',
    'tiktok.form.status.processing': '⏳ Đang đăng',
    'tiktok.form.status.draft': '• Nháp',
    'tiktok.form.toast.oneVideo': 'Mỗi bài chỉ có thể có 1 video. Xoá media cũ trước.',
    'tiktok.form.toast.videoTooLong':
      'Video dài {dur}s vượt giới hạn {max}s của account này (theo Creator Info).',
    'tiktok.form.toast.videoUploadFail': 'Upload video thất bại.',
    'tiktok.form.toast.noMix': 'Không thể mix ảnh và video. Xoá video trước nếu muốn đăng photo.',
    'tiktok.form.toast.maxPhotos': 'Tối đa {max} ảnh trong 1 bài.',
    'tiktok.form.toast.imageUploadFail': 'Upload ảnh thất bại.',
    'tiktok.form.toast.selectAccount': 'Vui lòng chọn tài khoản TikTok.',
    'tiktok.form.toast.mediaRequired': 'TikTok bắt buộc có ít nhất 1 video hoặc ảnh.',
    'tiktok.form.toast.publicUnavailable':
      'Đăng công khai hiện chưa khả dụng. Vui lòng chọn chế độ khác.',
    'tiktok.form.toast.descTooLong': 'Mô tả vượt quá {max} ký tự.',
    'tiktok.form.toast.selectTime': 'Vui lòng chọn thời gian đăng.',
    'tiktok.form.toast.leadTime': 'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',
    'tiktok.form.toast.scheduleUpdated': 'Đã cập nhật lịch đăng.',
    'tiktok.form.toast.saved': 'Đã lưu thay đổi.',
    'tiktok.form.toast.saveFail': 'Lưu thất bại.',
    'tiktok.form.toast.published': 'Đăng bài thành công!',
    'tiktok.form.toast.sent': 'Đã gửi.',
    'tiktok.form.toast.scheduledAt': 'Đã lên lịch đăng lúc {time}.',
    'tiktok.form.toast.draftSaved': 'Đã lưu nháp.',
    'tiktok.form.toast.createFail': 'Tạo bài viết thất bại.',
    'tiktok.form.submit.updateSchedule': 'Cập nhật lịch',
    'tiktok.form.submit.saveChanges': 'Lưu thay đổi',
    'tiktok.form.submit.schedule': '📅 Lên lịch đăng',
    'tiktok.form.submit.publishNow': '🚀 Đăng ngay',
    'tiktok.form.submit.saveDraft': 'Lưu nháp',
    'tiktok.form.editTitle': 'Sửa bài viết TikTok',
    'tiktok.form.createTitle': 'Tạo bài viết TikTok',
    'tiktok.form.subtitle': 'Upload video / ảnh và đăng lên TikTok qua Content Posting API.',
    'tiktok.form.step1.title': 'Đăng từ tài khoản nào?',
    'tiktok.form.step1.hint': 'Chọn tài khoản TikTok đã kết nối',
    'tiktok.form.accountLabel': 'Tài khoản TikTok',
    'tiktok.form.accountPlaceholder': 'Chọn tài khoản',
    'tiktok.form.noAccounts': 'Chưa có tài khoản TikTok nào kích hoạt',
    'tiktok.form.step2.title': 'Media (bắt buộc)',
    'tiktok.form.step2.hint': '1 video hoặc 1-{max} ảnh. Video ≤ 4GB.',
    'tiktok.form.addVideo': 'Thêm video',
    'tiktok.form.addPhoto': 'Thêm ảnh',
    'tiktok.form.uploading': 'Đang upload...',
    'tiktok.form.mediaCount': '{type} — {count} mục',
    'tiktok.form.noMedia': 'Chưa có media. TikTok bắt buộc có ít nhất 1 video/ảnh.',
    'tiktok.form.removeMedia': 'Xoá media',
    'tiktok.form.step3.title': 'Tiêu đề & mô tả',
    'tiktok.form.step3.hint': 'Mô tả tối đa {max} ký tự',
    'tiktok.form.titlePlaceholder': 'Tiêu đề video (tuỳ chọn)',
    'tiktok.form.descPlaceholder': 'Mô tả + hashtag (vd: #foryou #fyp ...)',
    'tiktok.form.step4.title': 'Tuỳ chọn đăng',
    'tiktok.form.step4.hint': 'Privacy (bắt buộc chọn), tương tác, nội dung thương mại',
    'tiktok.form.privacyLabel': 'Privacy',
    'tiktok.form.optionUnavailable': '{label} (chưa khả dụng)',
    'tiktok.form.allowedTitle': 'TikTok cho phép tài khoản này đăng ở chế độ:',
    'tiktok.form.publicNotApproved':
      '⚠ "Công khai" chưa khả dụng vì TikTok chưa audit-approve quyền đăng nội dung công khai cho app này (app "live" ≠ Content Posting API đã audit). Khi được duyệt, danh sách trên sẽ tự có "Công khai".',
    'tiktok.form.step5.title': 'Chế độ đăng',
    'tiktok.form.step5.hint': 'Lưu nháp, lên lịch tự động hoặc đăng ngay',
    'tiktok.form.mode.draft': 'Lưu nháp',
    'tiktok.form.mode.draftHint': 'Lưu để chỉnh sửa và đăng sau.',
    'tiktok.form.mode.schedule': 'Lên lịch',
    'tiktok.form.mode.scheduleHint': 'Tự động đăng vào thời điểm chỉ định.',
    'tiktok.form.mode.publish': 'Đăng ngay',
    'tiktok.form.mode.publishHint': 'Gửi bài lên TikTok ngay lập tức.',
    'tiktok.form.scheduleTime': 'Thời gian đăng',
    'tiktok.form.datePlaceholder': 'Chọn ngày và giờ đăng',
    'tiktok.form.timezonePrefix': 'Múi giờ:',
    'tiktok.form.minLeadSuffix': '. Tối thiểu cách hiện tại {min} phút.',
    'tiktok.form.willPostPrefix': '⏰ Sẽ đăng',
    'tiktok.form.previewTitle': 'Xem trước trên TikTok',
    'tiktok.form.behalfPrefix': 'Video sẽ được đăng lên TikTok thay mặt',
    'tiktok.form.behalfSuffix': ' qua Content Posting API.',
    'tiktok.form.usernameChanged':
      'Lưu ý: username TikTok hiện tại (@{current}) khác với username lúc kết nối. TikTok đã đổi tên — vẫn dùng được, danh tính chính xác là @{current}.',
    'tiktok.form.maxDurationPrefix': 'Account này cho phép video tối đa',
    'tiktok.form.maxDurationSuffix': '(theo Creator Info).',
    'tiktok.form.footer.schedule': 'Bài sẽ được hệ thống tự động đăng đúng thời điểm bạn chọn.',
    'tiktok.form.footer.publish':
      'Bài sẽ được đăng lên TikTok ngay khi bạn nhấn nút (có thể mất 1-5 phút processing).',
    'tiktok.form.footer.draft': 'Nháp có thể chỉnh sửa, lên lịch hoặc đăng bất cứ lúc nào.',
    'tiktok.form.cancel': 'Huỷ',

    'features.badge': 'TÍNH NĂNG',
    'features.title': 'Mọi thứ bạn cần để vận hành nội dung',
    'features.subtitle':
      'Từ sáng tạo, lên lịch đến đo lường — tích hợp sẵn, không cần lắp thêm công cụ khác.',
    'features.multiAccount.title': 'Quản lý đa tài khoản',
    'features.multiAccount.desc':
      'Kết nối không giới hạn fan page, kênh và profile trên 8 nền tảng — đăng nhập một lần, vận hành trong một workspace.',
    'features.scheduling.title': 'Lên lịch tự động',
    'features.scheduling.desc':
      'Soạn bài, chọn nền tảng đích và thời điểm — hệ thống đăng bài theo lịch, hỗ trợ sẵn timezone Asia/Ho_Chi_Minh.',
    'features.ai.title': 'Sinh nội dung bằng AI',
    'features.ai.desc':
      'Sinh caption, hashtag và ý tưởng video bằng Gemini — tinh chỉnh theo tone của từng nền tảng.',
    'features.security.title': 'Lưu token an toàn',
    'features.security.desc':
      'OAuth tuân thủ chuẩn với Meta, Google, TikTok và X. Mã hoá AES-256-GCM khi lưu, cảnh báo hết hạn chủ động.',
    'features.analytics.title': 'Analytics tập trung',
    'features.analytics.desc':
      'Một dashboard cho bài đã đăng, lịch sắp tới và tỷ lệ thành công — biết ngay đâu cần xử lý.',
    'features.crossPost.title': 'Đăng chéo nền tảng',
    'features.crossPost.desc':
      'Đẩy một video YouTube lên Facebook và X cùng lúc trong một lịch — tiết kiệm hàng giờ cross-post thủ công.',

    'how.badge': 'CÁCH HOẠT ĐỘNG',
    'how.title': 'Ba bước từ ý tưởng đến bài đăng',
    'how.subtitle': 'Từ đăng nhập đến bài đăng đầu tiên — setup dưới 10 phút.',
    'how.step1.title': 'Kết nối tài khoản',
    'how.step1.desc':
      'Đăng nhập một lần qua OAuth chính thức — Meta, Google, TikTok, X — để cấp quyền đăng bài thay bạn. Không lưu mật khẩu; access token được mã hoá AES-256-GCM khi lưu.',
    'how.step2.title': 'Soạn & lên lịch',
    'how.step2.desc':
      'Tạo nội dung bằng trình soạn rich-text hoặc để AI (Gemini) gợi ý caption và hashtag. Chọn nền tảng đích, ngày, giờ và timezone — lịch được lưu tức thì.',
    'how.step3.title': 'Tự đăng & theo dõi',
    'how.step3.desc':
      'Worker cron kích hoạt đúng giờ, gọi API từng nền tảng và ghi nhận thành công/thất bại. Dashboard hiện token sắp hết hạn, bài lỗi cần retry và lịch sắp tới.',

    'contact.badge': 'LIÊN HỆ',
    'contact.title': 'Cần hỗ trợ? Liên hệ trực tiếp',
    'contact.subtitle':
      'Đội ngũ phản hồi yêu cầu hỗ trợ kỹ thuật, hợp tác và dữ liệu trong vòng 30 ngày làm việc.',
    'contact.email.label': 'Email',
    'contact.support.label': 'Hỗ trợ kỹ thuật',
    'contact.support.desc': 'Legal Center có hướng dẫn cho từng tích hợp',
    'contact.support.cta': 'Truy cập Legal Center →',
    'contact.location.label': 'Đơn vị vận hành',
    'contact.location.company': 'WAEBOX Media',
    'contact.location.country': 'Việt Nam',

    'cta.title': 'Sẵn sàng đăng bài thông minh hơn?',
    'cta.subtitle':
      'Đăng nhập, kết nối nền tảng đầu tiên và lên lịch bài đăng đầu tiên trong vài phút.',
    'cta.signIn': 'Đăng nhập',
    'cta.dashboard': 'Vào Dashboard',

    'footer.brand': 'Social Panel',
    'footer.description':
      'Quản lý nội dung social tập trung — kết nối, lên lịch và đo lường bài đăng trên 8 mạng xã hội từ một dashboard.',
    'footer.legal': 'Legal Center',
    'footer.privacy': 'Quyền riêng tư',
    'footer.terms': 'Điều khoản',
    'footer.copy': '© {year} Social Panel · by WAEBOX Media',
    'footer.support':
      'Hỗ trợ Facebook · Instagram · Threads · YouTube · X (Twitter) · Pinterest · TikTok · Telegraph',

    'integrations.badge': 'TÍCH HỢP',
    'integrations.title': 'Mọi nền tảng được hỗ trợ, gom về một chỗ',
    'integrations.subtitle':
      'Mỗi tích hợp dùng API chính thức của nền tảng. Token OAuth được mã hoá AES-256-GCM khi lưu; client_secret luôn ở server-side.',
    'integrations.status.live': '● LIVE',
    'integrations.status.coming': '○ SẮP RA MẮT',
    'integrations.learnMore': 'Xem chi tiết',
    'integrations.backAll': 'Tất cả tích hợp',
    'integrations.hero.live': '● Đang hoạt động',
    'integrations.hero.coming': '○ Sắp ra mắt',
    'integrations.hero.titleSuffix': 'Tích hợp {name}',
    'integrations.products': 'Sản phẩm sử dụng',
    'integrations.scopes': 'OAuth scopes yêu cầu',
    'integrations.showcase.title': 'Luồng {name} hoàn chỉnh, từ đầu đến cuối',
    'integrations.showcase.coming': 'Showcase sắp ra mắt',
    'integrations.showcase.subtitle':
      'Mỗi màn hình bên dưới là screenshot thật từ dashboard Social Panel.',
    'integrations.showcase.comingDesc':
      'Tích hợp {name} đã chạy trong dashboard. Walkthrough chi tiết sẽ được đăng tại đây trong bản phát hành sắp tới.',
    'integrations.placeholder.text':
      'Screenshot của module {name} sẽ xuất hiện ở đây. Tích hợp đã chạy trên production — đăng nhập dashboard để dùng.',
    'integrations.placeholder.cta': 'Đăng nhập để thử',
    'integrations.compliance.title': 'Tuân thủ & bảo mật',
    'integrations.compliance.subtitle':
      'Cách chúng tôi xử lý thông tin xác thực và tuân theo hướng dẫn API của {name}.',
    'integrations.other.title': 'Tích hợp khác',
    'integrations.other.viewAll': 'Xem tất cả',
    'integrations.notFound.title': 'Không tìm thấy tích hợp',
    'integrations.notFound.desc': 'Không tìm thấy tích hợp nền tảng tên "{slug}".',
    'integrations.notFound.cta': 'Xem tất cả tích hợp',

    'integrations.useCases.badge': 'AI DÙNG APP NÀY',
    'integrations.useCases.title': 'Xây dựng cho luồng publish {name} thực tế',
    'integrations.useCases.subtitle': 'Use case cụ thể, justify cho từng scope app yêu cầu.',
    'integrations.scopeJust.badge': 'JUSTIFY SCOPE',
    'integrations.scopeJust.title': 'Tại sao cần từng scope',
    'integrations.scopeJust.subtitle':
      'Mỗi scope app yêu cầu được map tới một feature cụ thể trong dashboard.',
    'integrations.scopeJust.usedBy': 'Dùng cho',
    'integrations.testing.badge': 'CHO APP REVIEWER',
    'integrations.testing.title': 'Cách test tích hợp {name}',
    'integrations.testing.subtitle':
      'Credentials cho reviewer được cung cấp trong note submission App Review. Làm theo các bước dưới để tái hiện luồng end-to-end đầy đủ.',
    'integrations.faq.badge': 'CÂU HỎI THƯỜNG GẶP',
    'integrations.faq.title': 'Câu hỏi reviewer thường gặp',
    'integrations.faq.subtitle':
      'Trả lời các câu hỏi reviewer {name} thường hỏi về justify scope, xử lý token và tuân thủ chính sách.',

    'signin.username.label': 'Tên đăng nhập',
    'signin.password.label': 'Mật khẩu',
    'signin.password.show': 'Hiện mật khẩu',
    'signin.password.hide': 'Ẩn mật khẩu',
    'signin.submit': 'ĐĂNG NHẬP',
    'signin.footer.copy': '© {year} Social Panel',
    'signin.footer.terms': 'Điều khoản dịch vụ',
    'signin.footer.privacy': 'Chính sách quyền riêng tư',
    'signin.lang.label': 'Ngôn ngữ',

    // ===== Admin · Threads (song ngữ) =====
    'admin.lang.label': 'Ngôn ngữ',

    'threads.common.sync': 'Đồng bộ',
    'threads.common.cancel': 'Huỷ',
    'threads.common.reset': 'Đặt lại',
    'threads.common.search': 'Tìm kiếm',
    'threads.common.back': 'Quay lại danh sách',
    'threads.common.open': 'Mở',
    'threads.common.active': 'Đang hoạt động',
    'threads.common.disabled': 'Đã tắt',
    'threads.common.accountNotFound': 'Không tìm thấy tài khoản.',
    'threads.common.noCaption': '(Không có nội dung)',
    'threads.common.loading': 'Đang tải...',

    'threads.list.title': 'Tài khoản Threads',
    'threads.list.add': 'Thêm',
    'threads.list.searchLabel': 'Tìm kiếm tài khoản',

    'threads.table.col.account': 'Tài khoản',
    'threads.table.col.userId': 'User ID',
    'threads.table.col.tokenExpiry': 'Token hết hạn',
    'threads.table.col.status': 'Trạng thái',
    'threads.table.col.createdAt': 'Ngày tạo',
    'threads.table.col.actions': 'Thao tác',
    'threads.table.noUsername': 'chưa có username',
    'threads.table.expiredDays': 'Hết hạn {days} ngày',
    'threads.table.remainingDays': 'Còn {days} ngày',
    'threads.table.empty.title': 'Chưa có dữ liệu',
    'threads.table.empty.desc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',
    'threads.table.tooltip.openProfile': 'Mở profile trên Threads',
    'threads.table.tooltip.viewDetail': 'Xem chi tiết tài khoản',
    'threads.table.tooltip.rename': 'Đổi tên hiển thị',
    'threads.table.tooltip.disconnect': 'Ngắt kết nối (thu hồi quyền Threads)',
    'threads.table.toast.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'threads.table.toast.statusError': 'Thay đổi trạng thái tài khoản thất bại',

    'threads.disconnect.title': 'Ngắt kết nối tài khoản Threads?',
    'threads.disconnect.desc':
      'Hệ thống sẽ xoá long-lived access token và metadata được lưu cho tài khoản này. Quyền truy cập Threads trên Meta sẽ không còn hoạt động cho ứng dụng. Bạn có thể kết nối lại bất cứ lúc nào qua nút "Thêm".',
    'threads.disconnect.confirm': 'Ngắt kết nối',
    'threads.disconnect.toast.success': 'Đã ngắt kết nối tài khoản Threads.',
    'threads.disconnect.toast.error': 'Không thể ngắt kết nối.',

    'threads.form.title.connect': 'Kết nối tài khoản Threads',
    'threads.form.title.update': 'Cập nhật tài khoản Threads',
    'threads.form.subtitle.connect': 'Đăng nhập Threads để cấp quyền đăng bài qua OAuth.',
    'threads.form.subtitle.update':
      'Đổi tên hiển thị trong hệ thống. Để cập nhật token, hãy ngắt kết nối và kết nối lại.',
    'threads.form.signIn': 'Đăng nhập Threads',
    'threads.form.signInAgain': 'Đăng nhập lại',
    'threads.form.authenticating': 'Đang xác thực với Threads...',
    'threads.form.scopes':
      'Quyền sẽ cấp: {scopes}. App giữ token trên server, không thấy mật khẩu của bạn.',
    'threads.form.openThreads': 'Mở Threads',
    'threads.form.field.name': 'Tên hiển thị trong hệ thống',
    'threads.form.field.username': 'Username Threads',
    'threads.form.field.userId': 'Threads User ID',
    'threads.form.field.avatar': 'Ảnh đại diện (URL)',
    'threads.form.cancel': 'Huỷ',
    'threads.form.saving': 'Đang lưu...',
    'threads.form.update': 'Cập nhật',
    'threads.form.done': 'Xong',
    'threads.form.toast.alreadyConnected':
      'Tài khoản Threads này đã được kết nối. Đang mở chi tiết...',
    'threads.form.toast.fetched': 'Lấy thông tin Threads thành công. Bấm "Xong" để lưu tài khoản.',
    'threads.form.toast.connectError': 'Không thể kết nối Threads. Vui lòng thử lại.',
    'threads.form.toast.updated': 'Cập nhật tài khoản Threads thành công.',
    'threads.form.toast.needLogin': 'Vui lòng đăng nhập Threads trước.',
    'threads.form.toast.saved': 'Lưu tài khoản Threads thành công.',
    'threads.form.toast.updateError': 'Không thể cập nhật tài khoản Threads.',
    'threads.form.toast.saveError': 'Không thể lưu tài khoản Threads.',
    'threads.form.oauth.accessDenied': 'Bạn đã từ chối cấp quyền cho ứng dụng (access_denied).',
    'threads.form.oauth.invalidRequest': 'Yêu cầu OAuth không hợp lệ. Vui lòng thử lại.',
    'threads.form.oauth.serverError': 'Threads tạm thời gặp lỗi. Vui lòng thử lại sau.',
    'threads.form.oauth.rejected': 'Threads từ chối: {description}',
    'threads.form.oauth.error': 'Threads trả về lỗi: {error}',
    'threads.form.oauth.stateMismatch':
      'OAuth state không khớp. Vui lòng đăng nhập lại để tránh tấn công CSRF.',

    'threads.detail.stat.followers': 'Followers',
    'threads.detail.stat.synced': 'Đã đồng bộ',
    'threads.detail.stat.userId': 'User ID',
    'threads.detail.btn.sync': 'Đồng bộ từ Threads',
    'threads.detail.btn.viewAll': 'Xem toàn bộ bài viết',
    'threads.detail.btn.disconnect': 'Ngắt kết nối',
    'threads.detail.syncedAgo': 'Đồng bộ {ago}',
    'threads.detail.posts.title': 'Bài viết trên Threads',
    'threads.detail.posts.subtitle': 'Lấy qua API /me/threads với quyền threads_basic',
    'threads.detail.empty.title': 'Chưa có bài viết nào được đồng bộ',
    'threads.detail.empty.desc':
      'Bấm "Đồng bộ từ Threads" để lấy danh sách bài viết của tài khoản này.',
    'threads.detail.toast.synced': 'Đã đồng bộ {n} bài viết từ Threads.',
    'threads.detail.toast.syncError': 'Đồng bộ thất bại.',

    'threads.postsPage.filter.all': 'Tất cả',
    'threads.postsPage.filter.text': 'Văn bản',
    'threads.postsPage.filter.image': 'Ảnh',
    'threads.postsPage.filter.video': 'Video',
    'threads.postsPage.filter.carousel': 'Carousel',
    'threads.postsPage.empty.title': 'Chưa có bài viết nào',
    'threads.postsPage.empty.descFiltered':
      'Không có bài viết nào khớp với bộ lọc. Thử bộ lọc khác hoặc bấm "Đồng bộ" để lấy dữ liệu mới.',
    'threads.postsPage.empty.descDefault':
      'Bấm "Đồng bộ" để lấy danh sách bài viết mới nhất từ Threads.',
    'threads.postsPage.followers': 'followers',
    'threads.postsPage.postsSynced': 'bài đã đồng bộ',
    'threads.postsPage.toast.synced': 'Đã đồng bộ {n} bài viết mới nhất từ Threads.',
    'threads.postsPage.toast.syncError': 'Đồng bộ bài viết thất bại.',

    'threadsPost.list.title': 'Bài viết Threads',
    'threadsPost.list.create': 'Tạo bài viết',
    'threadsPost.list.searchLabel': 'Tìm kiếm',
    'threadsPost.list.searchPlaceholder': 'Tìm theo nội dung',
    'threadsPost.list.accountLabel': 'Tài khoản',
    'threadsPost.list.allAccounts': 'Tất cả tài khoản',
    'threadsPost.list.statusLabel': 'Trạng thái',
    'threadsPost.list.apply': 'Lọc',
    'threadsPost.list.reset': 'Đặt lại',
    'threadsPost.status.all': 'Tất cả trạng thái',
    'threadsPost.status.allShort': 'Tất cả',
    'threadsPost.status.draft': 'Nháp',
    'threadsPost.status.scheduled': 'Đã lên lịch',
    'threadsPost.status.published': 'Đã đăng',
    'threadsPost.status.failed': 'Lỗi',

    'threadsPost.table.badge.published': 'Đã đăng',
    'threadsPost.table.badge.failed': 'Lỗi',
    'threadsPost.table.badge.scheduled': '📅 Đã lên lịch',
    'threadsPost.table.badge.processing': '⏳ Đang đăng',
    'threadsPost.table.badge.draft': 'Nháp',
    'threadsPost.table.media.text': 'Văn bản',
    'threadsPost.table.media.items': '{n} mục',
    'threadsPost.table.time.waitingCron': 'Đang chờ cron xử lý',
    'threadsPost.table.time.publishing': 'Đang đăng…',
    'threadsPost.table.col.account': 'Tài khoản',
    'threadsPost.table.col.content': 'Nội dung',
    'threadsPost.table.col.media': 'Media',
    'threadsPost.table.col.status': 'Trạng thái',
    'threadsPost.table.col.time': 'Thời gian',
    'threadsPost.table.col.link': 'Link bài',
    'threadsPost.table.col.createdAt': 'Tạo lúc',
    'threadsPost.table.col.actions': 'Thao tác',
    'threadsPost.table.reschedule.title': 'Đổi giờ đăng',
    'threadsPost.table.reschedule.minLead': 'Cách hiện tại tối thiểu {min} phút.',
    'threadsPost.table.reschedule.placeholder': 'Chọn ngày giờ mới',
    'threadsPost.table.reschedule.save': 'Lưu lịch',
    'threadsPost.table.reschedule.invalid': 'Vui lòng chọn thời gian.',
    'threadsPost.table.reschedule.tooSoon': 'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',
    'threadsPost.table.delete.title': 'Xoá bài viết?',
    'threadsPost.table.delete.desc':
      'Bài viết sẽ bị xoá khỏi hệ thống. Bài đã đăng trên Threads vẫn còn.',
    'threadsPost.table.delete.confirm': 'Xoá',
    'threadsPost.table.toast.deleted': 'Đã xoá bài viết.',
    'threadsPost.table.publishNow.title': 'Đăng ngay bài đã lên lịch?',
    'threadsPost.table.publishNow.desc':
      'Lịch đăng tự động sẽ bị huỷ và bài sẽ được đăng ngay lập tức.',
    'threadsPost.table.publishNow.confirm': 'Đăng ngay',
    'threadsPost.table.toast.published': 'Đăng bài thành công.',
    'threadsPost.table.toast.publishError': 'Đăng bài thất bại.',
    'threadsPost.table.toast.retried': 'Đã thử đăng lại.',
    'threadsPost.table.toast.retryError': 'Thử lại thất bại.',
    'threadsPost.table.toast.rescheduled': 'Đã cập nhật lịch đăng.',
    'threadsPost.table.toast.rescheduleError': 'Cập nhật lịch thất bại.',
    'threadsPost.table.cancelSchedule.title': 'Huỷ lịch đăng?',
    'threadsPost.table.cancelSchedule.desc': 'Bài sẽ chuyển về trạng thái Nháp.',
    'threadsPost.table.cancelSchedule.confirm': 'Huỷ lịch',
    'threadsPost.table.toast.scheduleCancelled': 'Đã huỷ lịch đăng.',
    'threadsPost.table.empty.title': 'Chưa có bài viết',
    'threadsPost.table.empty.desc': 'Tạo bài viết đầu tiên để đăng lên Threads',
    'threadsPost.table.tooltip.viewOnThreads': 'Xem trên Threads',
    'threadsPost.table.tooltip.reschedule': 'Đổi giờ đăng',
    'threadsPost.table.tooltip.cancelSchedule': 'Huỷ lịch đăng',
    'threadsPost.table.tooltip.retry': 'Thử đăng lại',
    'threadsPost.table.tooltip.publishNow': 'Đăng ngay',
    'threadsPost.table.tooltip.edit': 'Sửa bài viết',
    'threadsPost.table.tooltip.delete': 'Xoá bài viết',
    'threadsPost.table.copyLink': 'Sao chép link',

    'threadsPost.form.title.create': 'Tạo bài viết Threads',
    'threadsPost.form.title.edit': 'Sửa bài viết Threads',
    'threadsPost.form.subtitle': 'Soạn nội dung, đính kèm ảnh/video và đăng lên Threads.',
    'threadsPost.form.badge.published': '✓ Đã đăng',
    'threadsPost.form.badge.failed': '⚠ Lỗi',
    'threadsPost.form.badge.scheduled': '📅 Đã lên lịch',
    'threadsPost.form.badge.processing': '⏳ Đang đăng',
    'threadsPost.form.badge.draft': '• Nháp',
    'threadsPost.form.step1.title': 'Đăng từ tài khoản nào?',
    'threadsPost.form.step1.hint': 'Chọn tài khoản Threads đã kết nối',
    'threadsPost.form.field.account': 'Tài khoản Threads',
    'threadsPost.form.field.accountPlaceholder': 'Chọn tài khoản',
    'threadsPost.form.field.noAccounts': 'Chưa có tài khoản Threads nào kích hoạt',
    'threadsPost.form.step2.title': 'Soạn nội dung',
    'threadsPost.form.step2.hint': 'Tối đa {max} ký tự',
    'threadsPost.form.message.placeholder': 'Bạn đang nghĩ gì?',
    'threadsPost.form.step3.title': 'Ảnh / Video (tuỳ chọn)',
    'threadsPost.form.step3.hint': 'Tối đa {max} mục. Ảnh ≤ 8MB, video ≤ 1GB.',
    'threadsPost.form.addImage': 'Thêm ảnh',
    'threadsPost.form.addVideo': 'Thêm video',
    'threadsPost.form.uploading': 'Đang upload...',
    'threadsPost.form.carouselTag': 'Carousel — {n} mục',
    'threadsPost.form.noMedia': 'Chưa có media. Có thể đăng bài chỉ với văn bản.',
    'threadsPost.form.removeMedia': 'Xoá media',
    'threadsPost.form.step4.title': 'Chế độ đăng',
    'threadsPost.form.step4.hint': 'Lưu nháp, lên lịch tự động hoặc đăng ngay',
    'threadsPost.form.mode.draft.label': 'Lưu nháp',
    'threadsPost.form.mode.draft.hint': 'Lưu để chỉnh sửa và đăng sau.',
    'threadsPost.form.mode.schedule.label': 'Lên lịch',
    'threadsPost.form.mode.schedule.hint': 'Tự động đăng vào thời điểm chỉ định.',
    'threadsPost.form.mode.publish.label': 'Đăng ngay',
    'threadsPost.form.mode.publish.hint': 'Gửi bài lên Threads ngay lập tức.',
    'threadsPost.form.schedule.timeLabel': 'Thời gian đăng',
    'threadsPost.form.schedule.placeholder': 'Chọn ngày và giờ đăng',
    'threadsPost.form.schedule.tz': 'Múi giờ: {tz}. Tối thiểu cách hiện tại {min} phút.',
    'threadsPost.form.schedule.willPost': '⏰ Sẽ đăng',
    'threadsPost.form.preview.label': 'Xem trước',
    'threadsPost.form.preview.namePlaceholder': 'Tên hiển thị',
    'threadsPost.form.preview.contentPlaceholder': 'Nội dung bài sẽ hiển thị ở đây...',
    'threadsPost.form.preview.like': '❤ Thích',
    'threadsPost.form.preview.reply': '💬 Trả lời',
    'threadsPost.form.preview.repost': '🔁 Repost',
    'threadsPost.form.preview.share': '↗ Chia sẻ',
    'threadsPost.form.footer.schedule':
      'Bài sẽ được hệ thống tự động đăng đúng thời điểm bạn chọn.',
    'threadsPost.form.footer.publish': 'Bài sẽ được đăng lên Threads ngay khi bạn nhấn nút.',
    'threadsPost.form.footer.draft': 'Nháp có thể chỉnh sửa, lên lịch hoặc đăng bất cứ lúc nào.',
    'threadsPost.form.submit.editSchedule': 'Cập nhật lịch',
    'threadsPost.form.submit.editSave': 'Lưu thay đổi',
    'threadsPost.form.submit.schedule': '📅 Lên lịch đăng',
    'threadsPost.form.submit.publish': '🚀 Đăng ngay',
    'threadsPost.form.submit.draft': 'Lưu nháp',
    'threadsPost.form.cancel': 'Huỷ',
    'threadsPost.form.toast.maxItems': 'Tối đa {max} mục trong 1 bài.',
    'threadsPost.form.toast.imageUploadError': 'Upload ảnh thất bại.',
    'threadsPost.form.toast.videoUploadError': 'Upload video thất bại.',
    'threadsPost.form.validate.account': 'Vui lòng chọn tài khoản Threads.',
    'threadsPost.form.validate.content': 'Bài cần có nội dung hoặc ít nhất 1 media.',
    'threadsPost.form.validate.overLimit': 'Nội dung vượt quá {max} ký tự.',
    'threadsPost.form.validate.scheduleTime': 'Vui lòng chọn thời gian đăng.',
    'threadsPost.form.validate.scheduleTooSoon':
      'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',
    'threadsPost.form.toast.publishedNow': 'Đăng bài thành công!',
    'threadsPost.form.toast.sent': 'Đã gửi.',
    'threadsPost.form.toast.scheduled': 'Đã lên lịch đăng lúc {time}.',
    'threadsPost.form.toast.draftSaved': 'Đã lưu nháp.',
    'threadsPost.form.toast.editScheduleUpdated': 'Đã cập nhật lịch đăng.',
    'threadsPost.form.toast.editSaved': 'Đã lưu thay đổi.',
    'threadsPost.form.toast.editError': 'Lưu thất bại.',
    'threadsPost.form.toast.createError': 'Tạo bài viết thất bại.',

    // ===== Admin · Instagram (song ngữ) =====
    'instagram.common.search': 'Tìm kiếm',
    'instagram.common.reset': 'Đặt lại',
    'instagram.common.cancel': 'Huỷ',
    'instagram.common.back': 'Quay lại danh sách',
    'instagram.common.open': 'Mở',
    'instagram.common.active': 'Đang hoạt động',
    'instagram.common.disabled': 'Đã tắt',
    'instagram.common.accountNotFound': 'Không tìm thấy tài khoản.',
    'instagram.common.noCaption': '(Không có nội dung)',
    'instagram.common.loading': 'Đang tải...',

    'instagram.list.title': 'Tài khoản Instagram',
    'instagram.list.add': 'Thêm',
    'instagram.list.searchLabel': 'Tìm kiếm tài khoản',
    'instagram.list.searchPlaceholder': 'Nhập tên hoặc username...',

    'instagram.account.table.col.account': 'Tên tài khoản',
    'instagram.account.table.col.username': 'Username',
    'instagram.account.table.col.userId': 'User ID',
    'instagram.account.table.col.status': 'Trạng thái',
    'instagram.account.table.col.createdAt': 'Ngày tạo',
    'instagram.account.table.col.actions': 'Thao tác',
    'instagram.account.table.empty.title': 'Chưa có dữ liệu',
    'instagram.account.table.empty.desc': 'Hãy thêm bản ghi đầu tiên để bắt đầu',
    'instagram.account.table.tooltip.viewDetail': 'Xem chi tiết tài khoản',
    'instagram.account.table.tooltip.edit': 'Cập nhật tài khoản',
    'instagram.account.table.tooltip.disconnect': 'Ngắt kết nối (thu hồi quyền Instagram)',
    'instagram.account.table.toast.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'instagram.account.table.toast.statusError': 'Thay đổi trạng thái tài khoản thất bại',
    'instagram.account.table.toast.copied': 'Đã sao chép user id.',

    'instagram.disconnect.title': 'Ngắt kết nối tài khoản Instagram?',
    'instagram.disconnect.desc':
      'Hệ thống sẽ xoá access token và metadata được lưu cho tài khoản này. Quyền truy cập Instagram trên Meta sẽ không còn hoạt động cho ứng dụng. Bạn có thể kết nối lại bất cứ lúc nào qua nút "Thêm".',
    'instagram.disconnect.confirm': 'Ngắt kết nối',
    'instagram.disconnect.toast.success': 'Đã ngắt kết nối tài khoản Instagram.',
    'instagram.disconnect.toast.error': 'Không thể ngắt kết nối.',

    'instagram.form.title.create': 'Tạo tài khoản Instagram',
    'instagram.form.title.update': 'Cập nhật tài khoản Instagram',
    'instagram.form.signIn': 'Đăng nhập Instagram',
    'instagram.form.signInAgain': 'Đăng nhập lại Instagram',
    'instagram.form.fetchedChip': 'Đã lấy thông tin từ Instagram',
    'instagram.form.field.name': 'Tên',
    'instagram.form.field.username': 'Tên người dùng',
    'instagram.form.field.userId': 'User ID',
    'instagram.form.field.active': 'Kích hoạt',
    'instagram.form.create': 'Tạo',
    'instagram.form.update': 'Cập nhật',
    'instagram.form.toast.missingClientId': 'Thiếu cấu hình REACT_APP_INSTAGRAM_CLIENT_ID.',
    'instagram.form.toast.userDenied':
      'Bạn đã từ chối cấp quyền. Cần cấp đủ {scopes} để có thể đăng bài lên Instagram.',
    'instagram.form.toast.rejected': 'Instagram từ chối đăng nhập: {description}',
    'instagram.form.toast.stateMismatch': 'State OAuth không hợp lệ, vui lòng đăng nhập lại.',
    'instagram.form.toast.fetchError': 'Lấy thông tin Instagram thất bại',
    'instagram.form.toast.needLogin': 'Bạn cần đăng nhập Instagram trước khi tạo tài khoản.',
    'instagram.form.toast.created': 'Tạo tài khoản thành công.',
    'instagram.form.toast.createError': 'Tạo tài khoản thất bại.',
    'instagram.form.toast.updated': 'Cập nhật tài khoản thành công.',
    'instagram.form.toast.updateError': 'Cập nhật tài khoản thất bại.',
    'instagram.form.toast.alreadyConnected':
      'Tài khoản Instagram này đã được kết nối. Đang mở chi tiết...',
    'instagram.form.oauth.accessDenied':
      'Bạn đã hủy cấp quyền trên màn hình đồng ý của Instagram. Cần cấp đủ instagram_business_basic và instagram_business_content_publish để kết nối tài khoản.',
    'instagram.form.oauth.invalidRequest':
      'Yêu cầu OAuth không hợp lệ (redirect URI hoặc cấu hình app sai). Vui lòng thử lại.',
    'instagram.form.oauth.serverError':
      'Instagram gặp lỗi máy chủ trong quá trình đăng nhập. Vui lòng thử lại sau ít phút.',
    'instagram.form.oauth.rejected': 'Instagram từ chối đăng nhập: {description}',
    'instagram.form.oauth.error': 'Đăng nhập Instagram thất bại: {error}',

    'instagram.detail.stat.followers': 'Followers',
    'instagram.detail.stat.posts': 'Bài đăng',
    'instagram.detail.stat.userId': 'User ID',
    'instagram.detail.accountType': 'Loại tài khoản',
    'instagram.detail.btn.sync': 'Đồng bộ từ Instagram',
    'instagram.detail.btn.disconnect': 'Ngắt kết nối',
    'instagram.detail.openProfile': 'Mở profile Instagram',
    'instagram.detail.posts.title': 'Bài viết trên Instagram',
    'instagram.detail.posts.subtitle': 'Lấy qua API /me/media với quyền instagram_business_basic',
    'instagram.detail.empty.title': 'Chưa có bài viết nào',
    'instagram.detail.empty.desc':
      'Bấm "Đồng bộ từ Instagram" để lấy bài viết mới nhất của tài khoản này.',
    'instagram.detail.toast.synced': 'Đã đồng bộ profile và bài viết từ Instagram.',
    'instagram.detail.toast.syncError':
      'Đồng bộ thất bại. Token có thể đã hết hạn — hãy kết nối lại.',

    'instagram.post.list.title': 'Bài viết Instagram',
    'instagram.post.list.create': 'Tạo bài viết',
    'instagram.post.list.searchLabel': 'Tìm kiếm',
    'instagram.post.list.searchPlaceholder': 'Tìm theo caption',
    'instagram.post.list.accountLabel': 'Tài khoản',
    'instagram.post.list.allAccounts': 'Tất cả tài khoản',
    'instagram.post.list.statusLabel': 'Trạng thái',
    'instagram.post.list.apply': 'Lọc',
    'instagram.post.list.reset': 'Đặt lại',
    'instagram.post.status.all': 'Tất cả trạng thái',
    'instagram.post.status.allShort': 'Tất cả',
    'instagram.post.status.draft': 'Nháp',
    'instagram.post.status.scheduled': 'Đã lên lịch',
    'instagram.post.status.published': 'Đã đăng',
    'instagram.post.status.failed': 'Lỗi',

    'instagram.post.table.col.account': 'Tài khoản',
    'instagram.post.table.col.media': 'Media',
    'instagram.post.table.col.caption': 'Caption',
    'instagram.post.table.col.status': 'Trạng thái',
    'instagram.post.table.col.time': 'Thời gian',
    'instagram.post.table.col.link': 'Link bài',
    'instagram.post.table.col.createdAt': 'Tạo lúc',
    'instagram.post.table.col.actions': 'Thao tác',
    'instagram.post.table.badge.published': 'Đã đăng',
    'instagram.post.table.badge.failed': 'Lỗi',
    'instagram.post.table.badge.scheduled': '📅 Đã lên lịch',
    'instagram.post.table.badge.processing': '⏳ Đang đăng',
    'instagram.post.table.badge.draft': 'Nháp',
    'instagram.post.table.media.carousel': '📷 Carousel · {count}',
    'instagram.post.table.media.reels': '🎬 Reels',
    'instagram.post.table.media.image': '🖼 Ảnh',
    'instagram.post.table.time.waitingCron': 'Đang chờ cron xử lý',
    'instagram.post.table.time.processing': 'Đang đăng…',
    'instagram.post.table.empty.title': 'Chưa có bài viết',
    'instagram.post.table.empty.desc': 'Tạo bài đầu tiên để đăng lên Instagram',
    'instagram.post.table.reschedule.title': 'Đổi giờ đăng',
    'instagram.post.table.reschedule.placeholder': 'Chọn ngày giờ mới',
    'instagram.post.table.reschedule.minLead': 'Cách hiện tại tối thiểu {min} phút.',
    'instagram.post.table.reschedule.save': 'Lưu lịch',
    'instagram.post.table.tooltip.open': 'Xem trên Instagram',
    'instagram.post.table.copyLink': 'Sao chép link',
    'instagram.post.table.tooltip.reschedule': 'Đổi giờ đăng',
    'instagram.post.table.tooltip.cancelSchedule': 'Huỷ lịch đăng',
    'instagram.post.table.tooltip.publishNow': 'Đăng ngay',
    'instagram.post.table.tooltip.edit': 'Sửa bài viết',
    'instagram.post.table.tooltip.delete': 'Xoá bài viết',
    'instagram.post.table.confirm.delete.title': 'Xoá bài viết?',
    'instagram.post.table.confirm.delete.desc':
      'Bài viết sẽ bị xoá khỏi hệ thống. Bài đã đăng trên Instagram vẫn còn.',
    'instagram.post.table.confirm.delete.confirm': 'Xoá',
    'instagram.post.table.confirm.publish.title': 'Đăng ngay bài đã lên lịch?',
    'instagram.post.table.confirm.publish.desc':
      'Lịch đăng tự động sẽ bị huỷ và bài sẽ được đăng ngay lập tức.',
    'instagram.post.table.confirm.publish.confirm': 'Đăng ngay',
    'instagram.post.table.confirm.cancel.title': 'Huỷ lịch đăng?',
    'instagram.post.table.confirm.cancel.desc':
      'Bài sẽ chuyển về trạng thái Nháp và không tự động đăng nữa.',
    'instagram.post.table.confirm.cancel.confirm': 'Huỷ lịch',
    'instagram.post.table.toast.deleted': 'Đã xoá bài viết.',
    'instagram.post.table.toast.published': 'Đăng bài thành công.',
    'instagram.post.table.toast.publishError': 'Đăng bài thất bại.',
    'instagram.post.table.toast.rescheduled': 'Đã cập nhật lịch đăng.',
    'instagram.post.table.toast.rescheduleError': 'Cập nhật lịch thất bại.',
    'instagram.post.table.toast.cancelled': 'Đã huỷ lịch đăng.',
    'instagram.post.table.toast.cancelError': 'Huỷ lịch thất bại.',
    'instagram.post.table.validate.pickTime': 'Vui lòng chọn thời gian.',
    'instagram.post.table.validate.tooSoon':
      'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',

    'instagram.post.form.title.create': 'Tạo bài viết Instagram',
    'instagram.post.form.title.edit': 'Sửa bài viết Instagram',
    'instagram.post.form.subtitle':
      'Chọn tài khoản, upload media, soạn caption. Lưu nháp, lên lịch hoặc đăng ngay.',
    'instagram.post.form.badge.published': '✓ Đã đăng',
    'instagram.post.form.badge.failed': '⚠ Lỗi',
    'instagram.post.form.badge.scheduled': '📅 Đã lên lịch',
    'instagram.post.form.badge.processing': '⏳ Đang đăng',
    'instagram.post.form.badge.draft': '• Nháp',
    'instagram.post.form.step1.title': 'Đăng từ tài khoản nào?',
    'instagram.post.form.step1.hint': 'Chọn tài khoản Instagram Business đã liên kết',
    'instagram.post.form.field.account': 'Tài khoản Instagram',
    'instagram.post.form.field.accountPlaceholder': 'Chọn tài khoản',
    'instagram.post.form.field.noAccounts': 'Chưa có tài khoản Instagram nào',
    'instagram.post.form.step2.title': 'Loại bài đăng',
    'instagram.post.form.step2.hint': 'Chọn loại nội dung phù hợp',
    'instagram.post.form.media.image.label': 'Ảnh đơn',
    'instagram.post.form.media.image.hint': '1 ảnh đăng lên feed',
    'instagram.post.form.media.carousel.label': 'Carousel',
    'instagram.post.form.media.carousel.hint': '2-10 ảnh, vuốt qua từng ảnh',
    'instagram.post.form.media.reels.label': 'Reels',
    'instagram.post.form.media.reels.hint': '1 video dọc, đăng dạng Reels',
    'instagram.post.form.step3.title': 'Media',
    'instagram.post.form.step3.hint.image': 'Upload 1 ảnh (jpg/png/webp)',
    'instagram.post.form.step3.hint.carousel': 'Upload 2-{max} ảnh, kéo thả sắp xếp',
    'instagram.post.form.step3.hint.reels': 'Upload 1 video mp4 (Reels)',
    'instagram.post.form.addImage': 'Thêm ảnh',
    'instagram.post.form.addVideo': 'Thêm video',
    'instagram.post.form.carouselCount': 'Đã upload: {n}/{max} ảnh',
    'instagram.post.form.removeMedia': 'Xoá media',
    'instagram.post.form.confirmChangeType': 'Đổi loại media sẽ xoá media đã upload. Tiếp tục?',
    'instagram.post.form.step4.title': 'Caption',
    'instagram.post.form.step4.hint': 'Tối đa {max} ký tự',
    'instagram.post.form.caption.placeholder': 'Nội dung caption, mô tả, hashtag...',
    'instagram.post.form.step5.title': 'Chế độ đăng',
    'instagram.post.form.step5.hint': 'Lưu nháp, lên lịch tự động hoặc đăng ngay',
    'instagram.post.form.mode.draft.label': 'Lưu nháp',
    'instagram.post.form.mode.draft.hint': 'Lưu lại để chỉnh sửa, đăng sau.',
    'instagram.post.form.mode.schedule.label': 'Lên lịch',
    'instagram.post.form.mode.schedule.hint': 'Tự động đăng vào ngày giờ chỉ định.',
    'instagram.post.form.mode.publish.label': 'Đăng ngay',
    'instagram.post.form.mode.publish.hint': 'Gửi lên Instagram lập tức.',
    'instagram.post.form.schedule.timeLabel': 'Thời gian đăng',
    'instagram.post.form.schedule.placeholder': 'Chọn ngày và giờ đăng',
    'instagram.post.form.schedule.tz': 'Múi giờ: {tz}. Tối thiểu cách hiện tại {min} phút.',
    'instagram.post.form.schedule.willPost': '⏰ Sẽ đăng',
    'instagram.post.form.preview.label': 'Xem trước',
    'instagram.post.form.preview.account': 'Tài khoản',
    'instagram.post.form.preview.now': 'Bây giờ',
    'instagram.post.form.preview.noMedia': 'Chưa có media',
    'instagram.post.form.preview.captionPlaceholder': 'Caption sẽ hiển thị ở đây...',
    'instagram.post.form.footer.schedule':
      'Bài sẽ được hệ thống tự động đăng đúng thời điểm bạn chọn.',
    'instagram.post.form.footer.publish': 'Bài sẽ được gửi lên Instagram ngay khi bạn nhấn nút.',
    'instagram.post.form.footer.draft': 'Nháp có thể chỉnh sửa, lên lịch hoặc đăng bất cứ lúc nào.',
    'instagram.post.form.submit.editSchedule': 'Cập nhật lịch',
    'instagram.post.form.submit.editSave': 'Lưu thay đổi',
    'instagram.post.form.submit.schedule': '📅 Lên lịch đăng',
    'instagram.post.form.submit.publish': '🚀 Đăng ngay',
    'instagram.post.form.submit.draft': 'Lưu nháp',
    'instagram.post.form.cancel': 'Huỷ',
    'instagram.post.form.validate.account': 'Vui lòng chọn tài khoản Instagram.',
    'instagram.post.form.validate.media': 'Vui lòng thêm media.',
    'instagram.post.form.validate.imageOne': 'Ảnh đơn cần đúng 1 ảnh.',
    'instagram.post.form.validate.carouselRange': 'Carousel cần 2-{max} ảnh.',
    'instagram.post.form.validate.reelsOne': 'Reels cần đúng 1 video.',
    'instagram.post.form.validate.captionLimit': 'Caption tối đa {max} ký tự.',
    'instagram.post.form.validate.scheduleTime': 'Vui lòng chọn thời gian đăng.',
    'instagram.post.form.validate.scheduleTooSoon':
      'Thời gian đăng phải cách hiện tại ít nhất {min} phút.',
    'instagram.post.form.toast.imageOnlyOne': 'Ảnh đơn chỉ chấp nhận 1 file.',
    'instagram.post.form.toast.carouselMax': 'Carousel tối đa {max} ảnh.',
    'instagram.post.form.toast.imageUploadError': 'Upload ảnh thất bại.',
    'instagram.post.form.toast.videoUploadError': 'Upload video thất bại.',
    'instagram.post.form.toast.publishedNow': 'Đăng bài thành công!',
    'instagram.post.form.toast.sent': 'Đã gửi.',
    'instagram.post.form.toast.scheduled': 'Đã lên lịch đăng lúc {time}.',
    'instagram.post.form.toast.draftSaved': 'Đã lưu nháp.',
    'instagram.post.form.toast.editScheduleUpdated': 'Đã cập nhật lịch đăng.',
    'instagram.post.form.toast.editSaved': 'Đã lưu thay đổi.',
    'instagram.post.form.toast.editError': 'Lưu thất bại.',
    'instagram.post.form.toast.createError': 'Tạo bài viết thất bại.',

    // ===== Admin · Dashboard (trang chủ /admin) =====
    'admin.dash.greeting.morning': 'Chào buổi sáng',
    'admin.dash.greeting.noon': 'Chào buổi trưa',
    'admin.dash.greeting.afternoon': 'Chào buổi chiều',
    'admin.dash.greeting.evening': 'Chào buổi tối',

    'admin.dash.health.attention': 'Cần chú ý',
    'admin.dash.health.warning': 'Có cảnh báo',
    'admin.dash.health.stable': 'Hoạt động ổn định',

    'admin.dash.status.draft': 'Nháp',
    'admin.dash.status.scheduled': 'Đã lên lịch',
    'admin.dash.status.processing': 'Đang xử lý',
    'admin.dash.status.published': 'Đã đăng',
    'admin.dash.status.failed': 'Lỗi',

    'admin.dash.header.summary': '{accounts} tài khoản · {posts} bài viết',
    'admin.dash.header.refresh': 'Làm mới',
    'admin.dash.header.export': 'Xuất Excel',
    'admin.dash.header.exporting': 'Đang xuất',
    'admin.dash.toast.exportSuccess': 'Xuất báo cáo thành công',
    'admin.dash.toast.exportError': 'Không xuất được báo cáo. Vui lòng thử lại.',
    'admin.dash.error.title': 'Không tải được thống kê.',
    'admin.dash.error.hint': 'Kiểm tra kết nối API hoặc đăng nhập lại.',

    'admin.dash.kpi.posted24h': 'Đã đăng 24h',
    'admin.dash.kpi.vsYesterday': 'so với hôm qua',
    'admin.dash.kpi.successRate7d': 'Tỷ lệ thành công 7d',
    'admin.dash.kpi.successSub': '{posted} đăng / {failed} lỗi',
    'admin.dash.kpi.scheduledNext24h': 'Lên lịch 24h tới',
    'admin.dash.kpi.failed24h': 'Thất bại 24h',
    'admin.dash.kpi.needReview': 'Cần xem xét',
    'admin.dash.kpi.none': 'Không có',
    'admin.dash.kpi.tokenExpiring': 'Token < 7 ngày',
    'admin.dash.kpi.needReconnect': 'Cần reconnect',
    'admin.dash.kpi.safe': 'An toàn',

    'admin.dash.trend.title': 'Xu hướng đăng bài 14 ngày',
    'admin.dash.trend.subtitle': 'Số bài đăng thành công theo nền tảng',
    'admin.dash.trend.total14d': 'Tổng 14 ngày',
    'admin.dash.trend.empty': 'Chưa có dữ liệu đăng bài trong 14 ngày qua',

    'admin.dash.platform.title': 'Phân bổ theo nền tảng',
    'admin.dash.platform.subtitle': 'Số bài viết — click vào dòng để mở list',
    'admin.dash.platform.totalLabel': 'Tổng bài',
    'admin.dash.platform.tooltipSuffix': 'bài',
    'admin.dash.platform.empty': 'Chưa có bài viết nào',

    'admin.dash.statusChart.title': 'Trạng thái bài viết',
    'admin.dash.statusChart.subtitle': 'Phân bổ theo trạng thái xử lý',
    'admin.dash.statusChart.totalLabel': 'Tổng',
    'admin.dash.statusChart.empty': 'Chưa có bài viết',

    'admin.dash.tokens.title': 'Token sắp hết hạn',
    'admin.dash.tokens.range': '14 ngày tới',
    'admin.dash.tokens.empty': 'Không có token nào sắp hết hạn',
    'admin.dash.tokens.daysLeft': 'Còn {days} ngày',
    'admin.dash.tokens.view': 'Xem',

    'admin.dash.schedules.title': 'Lịch đăng sắp tới',
    'admin.dash.schedules.range': '7 ngày tới',
    'admin.dash.schedules.empty': 'Không có bài đã lên lịch trong 7 ngày tới',

    'admin.dash.activity.title': 'Hoạt động gần đây',
    'admin.dash.activity.failedCount': '{count} lỗi',
    'admin.dash.activity.empty': 'Chưa có hoạt động đăng bài gần đây',
  },

  en: {
    'header.nav.platforms': 'Platforms',
    'header.nav.features': 'Features',
    'header.nav.howItWorks': 'How it works',
    'header.nav.contact': 'Contact',
    'header.nav.legal': 'Legal',
    'header.cta.signIn': 'Sign in',
    'header.cta.dashboard': 'Go to Dashboard',
    'header.lang.label': 'Language',
    'header.lang.vi': 'Tiếng Việt',
    'header.lang.en': 'English',

    'hero.badge': 'Social Posting Control · 8 Platforms',
    'hero.title.line1': 'One dashboard, post to',
    'hero.title.line2': 'every social network.',
    'hero.subtitle':
      'Connect Facebook, Instagram, Threads, YouTube, X, Pinterest, TikTok, and Telegraph. Create content, schedule, and track — all in one place.',
    'hero.cta.signIn': 'Sign in',
    'hero.cta.dashboard': 'Go to Dashboard',
    'hero.trust': 'Trusted by content teams managing accounts across 8 social platforms',

    'platforms.badge': 'SUPPORTED PLATFORMS',
    'platforms.title': '8 social networks, ready to connect',
    'platforms.subtitle':
      'Official OAuth integrations with every platform — no stored passwords, no browser plugins.',
    'platforms.live': 'LIVE',
    'platforms.viewAll': 'View all integrations',
    'platform.tiktok.tagline': 'Short-form video publishing',
    'platform.facebook.tagline': 'Page posts & scheduling',
    'platform.instagram.tagline': 'Feed posts, carousels & Reels',

    // Messenger inbox (admin)
    'messenger.title': 'Messenger Inbox',
    'messenger.selectPage': 'Select a Page',
    'messenger.noPages': 'No Pages yet',
    'messenger.managePages': 'Manage Pages',
    'messenger.you': 'You',
    'messenger.empty.connectPrompt':
      'No Page has Messenger enabled yet. Click "Manage Pages" to pick a Facebook Page and turn on message replies.',
    'messenger.empty.noConversations': 'No conversations yet.',
    'messenger.thread.selectPrompt': 'Select a conversation to read and reply to messages.',
    'messenger.reply.placeholder': 'Type a reply… (Enter to send)',
    'messenger.reply.send': 'Send',
    'messenger.reply.failed': 'Failed to send',
    'messenger.pages.title': 'Manage Messenger Pages',
    'messenger.pages.description':
      'Enable Messenger per Page to receive and reply to messages right inside the inbox.',
    'messenger.pages.account': 'Facebook account',
    'messenger.pages.selectAccount': 'Select an account',
    'messenger.pages.noPages': 'This account does not administer any Page.',
    'messenger.pages.enable': 'Enable',
    'messenger.pages.disconnect': 'Disconnect',
    'messenger.pages.close': 'Close',
    'messenger.pages.loadFailed': 'Failed to load Pages',
    'messenger.pages.subscribed': 'Messenger enabled for {name}',
    'messenger.pages.unsubscribed': 'Messenger disabled for {name}',
    'messenger.pages.subscribeFailed': 'Failed to enable Messenger',
    'messenger.pages.unsubscribeFailed': 'Failed to disable Messenger',
    'messenger.clearHistory': 'Clear history',
    'messenger.delete.title': 'Delete conversation',
    'messenger.delete.desc':
      'Remove this conversation from the inbox? This only deletes the copy stored in our system and does not affect the user’s Messenger. If they message again, the conversation will reappear.',
    'messenger.delete.confirm': 'Delete',
    'messenger.delete.success': 'Conversation deleted',
    'messenger.delete.failed': 'Failed to delete conversation',
    'messenger.clear.title': 'Clear all history',
    'messenger.clear.desc':
      'Delete all stored conversations and messages for this Page? This only deletes the copies stored in our system and does not affect the user’s Messenger. This action cannot be undone.',
    'messenger.clear.confirm': 'Delete all',
    'messenger.clear.success': 'All history cleared',
    'messenger.clear.failed': 'Failed to clear history',

    // Facebook account form (admin) — login flow for pages_messaging
    'fbForm.title.create': 'Connect Facebook account',
    'fbForm.title.update': 'Update Facebook account',
    'fbForm.login': 'Log in with Facebook',
    'fbForm.loginAgain': 'Log in with Facebook again',
    'fbForm.gotInfo': 'Fetched info from Facebook',
    'fbForm.currentAvatar': 'Current profile picture',
    'fbForm.field.name': 'Name',
    'fbForm.field.userId': 'User ID',
    'fbForm.field.picture': 'Profile picture (URL)',
    'fbForm.field.active': 'Active',
    'fbForm.cancel': 'Cancel',
    'fbForm.create': 'Create',
    'fbForm.update': 'Update',
    'fbForm.toast.missingClientId': 'Missing REACT_APP_FACEBOOK_CLIENT_ID configuration.',
    'fbForm.toast.invalidState': 'Invalid OAuth state, please log in again.',
    'fbForm.toast.loginDenied': 'Facebook denied the login: {reason}',
    'fbForm.toast.needLogin': 'You need to log in with Facebook before creating an account.',
    'fbForm.toast.createSuccess': 'Account created successfully.',
    'fbForm.toast.createFailed': 'Failed to create account.',
    'fbForm.toast.updateSuccess': 'Account updated successfully.',
    'fbForm.toast.updateFailed': 'Failed to update account.',

    'platform.threads.tagline': 'Threads posts via Meta API',
    'platform.youtube.tagline': 'Video uploads & metadata',
    'platform.x-twitter.tagline': 'Tweet scheduling & threads',
    'platform.pinterest.tagline': 'Pins & boards management',
    'platform.telegraph.tagline': 'Long-form article publishing',

    'tiktok.badge': 'TIKTOK INTEGRATION',
    'tiktok.title': 'The full TikTok workflow, end-to-end',
    'tiktok.subtitle':
      "Built on TikTok's Login Kit, Content Posting API, and Display API. Every screen honors TikTok's Content Sharing Guidelines and Branded Content Policy.",
    'tiktok.shot1.title': 'Connect via TikTok OAuth',
    'tiktok.shot1.desc':
      'Users authorize through the official TikTok consent screen using Login Kit (user.info.basic, user.info.profile). The client secret stays server-side.',
    'tiktok.shot2.title': 'Connected accounts workspace',
    'tiktok.shot2.desc':
      'All connected TikTok accounts in a single dashboard, with status toggles, quick links to the TikTok profile, and per-account actions.',
    'tiktok.shot3.title': 'Account detail & sync',
    'tiktok.shot3.desc':
      'Profile data fetched from TikTok — display name, username, avatar, bio — with a re-sync button and a 24h post-count meter.',
    'tiktok.shot4.title': 'Browse videos via Display API',
    'tiktok.shot4.desc':
      'Read-only video gallery using the video.list scope — cover, title, view/like/comment/share counts, cursor pagination.',
    'tiktok.shot5.title': 'Compose with creator_info gating',
    'tiktok.shot5.desc':
      'Post composer honors creator_info: allowed privacy levels, max video duration, account-level comment/duet/stitch locks, and Branded Content disclosure.',
    'tiktok.shot6.title': 'Publish via Content Posting API',
    'tiktok.shot6.desc':
      'video.upload + video.publish — the post goes live on TikTok and the returned share_url is stored for verification.',
    'tiktok.note.encrypted': 'OAuth tokens encrypted (AES-256-GCM)',
    'tiktok.note.serverSecret': 'Server-side client_secret',
    'tiktok.note.creatorInfo': 'Honors creator_info on every publish',

    // Compliance disclosure on the post composer (required by TikTok Direct
    // Post Developer Guidelines). Lead + trailing are split to inline the links.
    'tiktok.compliance.lead': "By posting, you agree to TikTok's",
    'tiktok.compliance.trailing': '.',
    'tiktok.compliance.and': 'and',
    'tiktok.compliance.musicLink': 'Music Usage Confirmation',
    'tiktok.compliance.brandedLink': 'Branded Content Policy',
    'tiktok.compliance.brandedNoPrivate':
      "Branded content (paid partnership) can't be posted with Private (Only me) visibility. Please choose a more public visibility.",
    // Composer — privacy (no default), interaction (allow-framing), commercial.
    'tiktok.privacy.placeholder': 'Select who can view this',
    'tiktok.privacy.required': 'Please select a privacy (visibility) level.',
    'tiktok.privacy.brandedNoPrivateTip': 'Branded content visibility cannot be set to private.',
    'tiktok.interaction.title': 'Allow users to',
    'tiktok.interaction.comment': 'Comment',
    'tiktok.interaction.duet': 'Duet',
    'tiktok.interaction.stitch': 'Stitch',
    'tiktok.interaction.accountOff': '(turned off by account)',
    'tiktok.commercial.master':
      'Indicate whether this content promotes yourself, a brand, product or service',
    'tiktok.commercial.masterHint': 'Turn on if your post contains promotional content.',
    'tiktok.commercial.yourBrand': 'Your Brand',
    'tiktok.commercial.yourBrandLabel':
      "Your photo/video will be labeled as 'Promotional content'.",
    'tiktok.commercial.brandedContent': 'Branded Content',
    'tiktok.commercial.brandedContentLabel':
      "Your photo/video will be labeled as 'Paid partnership'.",
    'tiktok.commercial.required':
      'You need to indicate if your content promotes yourself, a third party, or both',
    'tiktok.commercial.musicLibraryNote':
      'Music in Branded Content must be from the TikTok Commercial Music Library.',

    // ===== Admin · TikTok post form (Create/Edit) =====
    'tiktok.form.defaultName': 'Display name',
    'tiktok.form.captionPlaceholder': 'Your caption will appear here...',
    'tiktok.form.previewUpload': 'Upload a video/photo to preview',
    'tiktok.form.defaultPrivacy': 'Private',
    'tiktok.privacyOption.public': 'Public',
    'tiktok.privacyOption.mutual': 'Friends (mutual follow)',
    'tiktok.privacyOption.follower': 'Followers',
    'tiktok.privacyOption.selfOnly': 'Private (only me)',
    'tiktok.form.privacyDisallowed':
      '⚠ This account only allows: {list}. The server will reject other privacy levels.',
    'tiktok.form.status.published': '✓ Published',
    'tiktok.form.status.failed': '⚠ Failed',
    'tiktok.form.status.scheduled': '📅 Scheduled',
    'tiktok.form.status.processing': '⏳ Posting',
    'tiktok.form.status.draft': '• Draft',
    'tiktok.form.toast.oneVideo':
      'Each post can only have 1 video. Remove the existing media first.',
    'tiktok.form.toast.videoTooLong':
      "The video is {dur}s long, exceeding this account's {max}s limit (per Creator Info).",
    'tiktok.form.toast.videoUploadFail': 'Video upload failed.',
    'tiktok.form.toast.noMix':
      'Cannot mix photos and video. Remove the video first to post photos.',
    'tiktok.form.toast.maxPhotos': 'Up to {max} photos per post.',
    'tiktok.form.toast.imageUploadFail': 'Image upload failed.',
    'tiktok.form.toast.selectAccount': 'Please select a TikTok account.',
    'tiktok.form.toast.mediaRequired': 'TikTok requires at least 1 video or photo.',
    'tiktok.form.toast.publicUnavailable':
      'Public posting is currently unavailable. Please choose another visibility.',
    'tiktok.form.toast.descTooLong': 'The description exceeds {max} characters.',
    'tiktok.form.toast.selectTime': 'Please select a posting time.',
    'tiktok.form.toast.leadTime': 'The posting time must be at least {min} minutes from now.',
    'tiktok.form.toast.scheduleUpdated': 'Schedule updated.',
    'tiktok.form.toast.saved': 'Changes saved.',
    'tiktok.form.toast.saveFail': 'Save failed.',
    'tiktok.form.toast.published': 'Post published!',
    'tiktok.form.toast.sent': 'Sent.',
    'tiktok.form.toast.scheduledAt': 'Scheduled to publish at {time}.',
    'tiktok.form.toast.draftSaved': 'Draft saved.',
    'tiktok.form.toast.createFail': 'Failed to create the post.',
    'tiktok.form.submit.updateSchedule': 'Update schedule',
    'tiktok.form.submit.saveChanges': 'Save changes',
    'tiktok.form.submit.schedule': '📅 Schedule post',
    'tiktok.form.submit.publishNow': '🚀 Publish now',
    'tiktok.form.submit.saveDraft': 'Save draft',
    'tiktok.form.editTitle': 'Edit TikTok post',
    'tiktok.form.createTitle': 'Create TikTok post',
    'tiktok.form.subtitle':
      'Upload a video / photo and post to TikTok via the Content Posting API.',
    'tiktok.form.step1.title': 'Which account to post from?',
    'tiktok.form.step1.hint': 'Choose a connected TikTok account',
    'tiktok.form.accountLabel': 'TikTok account',
    'tiktok.form.accountPlaceholder': 'Select an account',
    'tiktok.form.noAccounts': 'No active TikTok accounts yet',
    'tiktok.form.step2.title': 'Media (required)',
    'tiktok.form.step2.hint': '1 video or 1-{max} photos. Video ≤ 4GB.',
    'tiktok.form.addVideo': 'Add video',
    'tiktok.form.addPhoto': 'Add photo',
    'tiktok.form.uploading': 'Uploading...',
    'tiktok.form.mediaCount': '{type} — {count} item(s)',
    'tiktok.form.noMedia': 'No media yet. TikTok requires at least 1 video/photo.',
    'tiktok.form.removeMedia': 'Remove media',
    'tiktok.form.step3.title': 'Title & description',
    'tiktok.form.step3.hint': 'Description up to {max} characters',
    'tiktok.form.titlePlaceholder': 'Video title (optional)',
    'tiktok.form.descPlaceholder': 'Description + hashtags (e.g. #foryou #fyp ...)',
    'tiktok.form.step4.title': 'Posting options',
    'tiktok.form.step4.hint': 'Privacy (required), interactions, commercial content',
    'tiktok.form.privacyLabel': 'Privacy',
    'tiktok.form.optionUnavailable': '{label} (unavailable)',
    'tiktok.form.allowedTitle': 'TikTok allows this account to post as:',
    'tiktok.form.publicNotApproved':
      '⚠ "Public" is not available yet because TikTok has not audit-approved public posting for this app (app "live" ≠ audited Content Posting API). Once approved, "Public" will appear in the list above.',
    'tiktok.form.step5.title': 'Posting mode',
    'tiktok.form.step5.hint': 'Save a draft, auto-schedule, or publish now',
    'tiktok.form.mode.draft': 'Save draft',
    'tiktok.form.mode.draftHint': 'Save to edit and post later.',
    'tiktok.form.mode.schedule': 'Schedule',
    'tiktok.form.mode.scheduleHint': 'Automatically post at a set time.',
    'tiktok.form.mode.publish': 'Publish now',
    'tiktok.form.mode.publishHint': 'Send the post to TikTok immediately.',
    'tiktok.form.scheduleTime': 'Posting time',
    'tiktok.form.datePlaceholder': 'Select posting date and time',
    'tiktok.form.timezonePrefix': 'Timezone:',
    'tiktok.form.minLeadSuffix': '. At least {min} minutes from now.',
    'tiktok.form.willPostPrefix': '⏰ Will post',
    'tiktok.form.previewTitle': 'Preview on TikTok',
    'tiktok.form.behalfPrefix': 'The video will be posted to TikTok on behalf of',
    'tiktok.form.behalfSuffix': ' via the Content Posting API.',
    'tiktok.form.usernameChanged':
      'Note: the current TikTok username (@{current}) differs from the one used at connection time. TikTok renamed it — it still works; the correct identity is @{current}.',
    'tiktok.form.maxDurationPrefix': 'This account allows videos up to',
    'tiktok.form.maxDurationSuffix': '(per Creator Info).',
    'tiktok.form.footer.schedule':
      'The post will be published automatically at the time you chose.',
    'tiktok.form.footer.publish':
      'The post will be published to TikTok as soon as you click (may take 1-5 minutes to process).',
    'tiktok.form.footer.draft': 'A draft can be edited, scheduled, or published anytime.',
    'tiktok.form.cancel': 'Cancel',

    'features.badge': 'FEATURES',
    'features.title': 'Everything you need to run your content',
    'features.subtitle':
      'From creation and scheduling to measurement — built in, no extra tools to stitch together.',
    'features.multiAccount.title': 'Multi-account management',
    'features.multiAccount.desc':
      'Connect unlimited fan pages, channels, and profiles across 8 platforms — sign in once, operate from a single workspace.',
    'features.scheduling.title': 'Automated scheduling',
    'features.scheduling.desc':
      'Compose a post, pick destination platforms and a time — the system publishes on schedule, with built-in Asia/Ho_Chi_Minh timezone support.',
    'features.ai.title': 'AI content generation',
    'features.ai.desc':
      'Generate captions, hashtags, and video ideas with Gemini — tuned to the tone of each platform.',
    'features.security.title': 'Secure token storage',
    'features.security.desc':
      'Standards-compliant OAuth with Meta, Google, TikTok, and X. AES-256-GCM encryption at rest, with proactive expiry alerts.',
    'features.analytics.title': 'Centralized analytics',
    'features.analytics.desc':
      'A single dashboard for posts published, upcoming schedule, and success rate — see exactly what needs your attention.',
    'features.crossPost.title': 'Cross-platform sharing',
    'features.crossPost.desc':
      'Push a single YouTube video to Facebook and X in one batch schedule — save hours of manual cross-posting.',

    'how.badge': 'HOW IT WORKS',
    'how.title': 'Three steps from idea to live post',
    'how.subtitle': 'From sign-in to your first published post — under 10 minutes of setup.',
    'how.step1.title': 'Connect your accounts',
    'how.step1.desc':
      'Sign in once with official OAuth — Meta, Google, TikTok, X — to grant posting permission on your behalf. No passwords are stored; access tokens are encrypted with AES-256-GCM at rest.',
    'how.step2.title': 'Compose & schedule',
    'how.step2.desc':
      'Create content with a rich-text editor or let AI (Gemini) suggest captions and hashtags. Choose destination platforms, date, time, and timezone — the schedule is saved instantly.',
    'how.step3.title': 'Auto-publish & monitor',
    'how.step3.desc':
      'A cron worker fires at the scheduled time, calls each platform API, and records success or failure. The dashboard surfaces expiring tokens, failed posts that need a retry, and upcoming schedules.',

    'contact.badge': 'CONTACT',
    'contact.title': 'Need help? Reach out directly',
    'contact.subtitle':
      'Our team responds to technical support, partnership, and data requests within 30 business days.',
    'contact.email.label': 'Email',
    'contact.support.label': 'Technical support',
    'contact.support.desc': 'Our Legal Center has a guide for every integration',
    'contact.support.cta': 'Visit the Legal Center →',
    'contact.location.label': 'Operated by',
    'contact.location.company': 'WAEBOX Media',
    'contact.location.country': 'Vietnam',

    'cta.title': 'Ready to post smarter?',
    'cta.subtitle':
      'Sign in with your account, connect your first platform, and schedule your first post in minutes.',
    'cta.signIn': 'Sign in',
    'cta.dashboard': 'Go to Dashboard',

    'footer.brand': 'Social Panel',
    'footer.description':
      'Centralized social content management — connect, schedule, and measure posts across 8 social networks from a single dashboard.',
    'footer.legal': 'Legal Center',
    'footer.privacy': 'Privacy',
    'footer.terms': 'Terms',
    'footer.copy': '© {year} Social Panel · by WAEBOX Media',
    'footer.support':
      'Supporting Facebook · Instagram · Threads · YouTube · X (Twitter) · Pinterest · TikTok · Telegraph',

    'integrations.badge': 'INTEGRATIONS',
    'integrations.title': 'Every supported platform, in one place',
    'integrations.subtitle':
      'Each integration uses the official API of the platform. OAuth tokens are encrypted at rest with AES-256-GCM; client secrets stay server-side.',
    'integrations.status.live': '● LIVE',
    'integrations.status.coming': '○ COMING SOON',
    'integrations.learnMore': 'Learn more',
    'integrations.backAll': 'All integrations',
    'integrations.hero.live': '● Live integration',
    'integrations.hero.coming': '○ Coming soon',
    'integrations.hero.titleSuffix': '{name} Integration',
    'integrations.products': 'Products used',
    'integrations.scopes': 'OAuth scopes requested',
    'integrations.showcase.title': 'The full {name} workflow, end-to-end',
    'integrations.showcase.coming': 'Showcase coming soon',
    'integrations.showcase.subtitle':
      'Every screen below is a real screenshot from the Social Panel dashboard.',
    'integrations.showcase.comingDesc':
      'The {name} integration is live in the dashboard. Detailed walkthrough screenshots will be published here in an upcoming release.',
    'integrations.placeholder.text':
      'Screenshots of the {name} module will appear here. The integration is already running in production — visit the dashboard to use it.',
    'integrations.placeholder.cta': 'Sign in to try it',
    'integrations.compliance.title': 'Compliance & security',
    'integrations.compliance.subtitle':
      "How we handle credentials and honor {name}'s API guidelines.",
    'integrations.other.title': 'Other integrations',
    'integrations.other.viewAll': 'View all',
    'integrations.notFound.title': 'Integration not found',
    'integrations.notFound.desc': 'We couldn\'t find a platform integration named "{slug}".',
    'integrations.notFound.cta': 'View all integrations',

    'integrations.useCases.badge': 'WHO USES THIS',
    'integrations.useCases.title': 'Built for real {name} publishing workflows',
    'integrations.useCases.subtitle':
      'Concrete use cases that justify each scope our app requests.',
    'integrations.scopeJust.badge': 'SCOPE JUSTIFICATION',
    'integrations.scopeJust.title': 'Why each scope is required',
    'integrations.scopeJust.subtitle':
      'Every scope our app requests is mapped to a concrete feature in the dashboard.',
    'integrations.scopeJust.usedBy': 'Used by',
    'integrations.testing.badge': 'FOR APP REVIEWERS',
    'integrations.testing.title': 'How to test the {name} integration',
    'integrations.testing.subtitle':
      'Reviewer credentials are provided in the App Review submission notes. Follow the steps below to reproduce the full end-to-end flow.',
    'integrations.faq.badge': 'FAQ',
    'integrations.faq.title': 'Common reviewer questions',
    'integrations.faq.subtitle':
      'Answers to questions {name} reviewers usually ask about scope justification, token handling, and policy compliance.',

    'signin.username.label': 'Username',
    'signin.password.label': 'Password',
    'signin.password.show': 'Show password',
    'signin.password.hide': 'Hide password',
    'signin.submit': 'SIGN IN',
    'signin.footer.copy': '© {year} Social Panel',
    'signin.footer.terms': 'Terms of Service',
    'signin.footer.privacy': 'Privacy Policy',
    'signin.lang.label': 'Language',

    // ===== Admin · Threads (bilingual) =====
    'admin.lang.label': 'Language',

    'threads.common.sync': 'Sync',
    'threads.common.cancel': 'Cancel',
    'threads.common.reset': 'Reset',
    'threads.common.search': 'Search',
    'threads.common.back': 'Back to list',
    'threads.common.open': 'Open',
    'threads.common.active': 'Active',
    'threads.common.disabled': 'Disabled',
    'threads.common.accountNotFound': 'Account not found.',
    'threads.common.noCaption': '(No caption)',
    'threads.common.loading': 'Loading…',

    'threads.list.title': 'Threads Accounts',
    'threads.list.add': 'Add',
    'threads.list.searchLabel': 'Search accounts',

    'threads.table.col.account': 'Account',
    'threads.table.col.userId': 'User ID',
    'threads.table.col.tokenExpiry': 'Token expiry',
    'threads.table.col.status': 'Status',
    'threads.table.col.createdAt': 'Created',
    'threads.table.col.actions': 'Actions',
    'threads.table.noUsername': 'no username yet',
    'threads.table.expiredDays': 'Expired {days}d ago',
    'threads.table.remainingDays': '{days}d left',
    'threads.table.empty.title': 'No data yet',
    'threads.table.empty.desc': 'Add your first record to get started',
    'threads.table.tooltip.openProfile': 'Open profile on Threads',
    'threads.table.tooltip.viewDetail': 'View account detail',
    'threads.table.tooltip.rename': 'Rename display name',
    'threads.table.tooltip.disconnect': 'Disconnect (revoke Threads access)',
    'threads.table.toast.statusChanged': 'Account status changed',
    'threads.table.toast.statusError': 'Could not change account status',

    'threads.disconnect.title': 'Disconnect this Threads account?',
    'threads.disconnect.desc':
      'We will delete the stored long-lived access token and metadata for this account. The app will lose Threads access on Meta until you connect again via "Add".',
    'threads.disconnect.confirm': 'Disconnect',
    'threads.disconnect.toast.success': 'Threads account disconnected.',
    'threads.disconnect.toast.error': 'Could not disconnect.',

    'threads.form.title.connect': 'Connect Threads account',
    'threads.form.title.update': 'Update Threads account',
    'threads.form.subtitle.connect': 'Sign in with Threads to grant publishing access via OAuth.',
    'threads.form.subtitle.update':
      'Rename the display name in our system. To refresh the token, disconnect and connect again.',
    'threads.form.signIn': 'Sign in with Threads',
    'threads.form.signInAgain': 'Sign in again',
    'threads.form.authenticating': 'Authenticating with Threads…',
    'threads.form.scopes':
      'Requested scopes: {scopes}. The token is stored on our server; we never see your password.',
    'threads.form.openThreads': 'Open Threads',
    'threads.form.field.name': 'Display name in our system',
    'threads.form.field.username': 'Threads username',
    'threads.form.field.userId': 'Threads User ID',
    'threads.form.field.avatar': 'Profile picture URL',
    'threads.form.cancel': 'Cancel',
    'threads.form.saving': 'Saving…',
    'threads.form.update': 'Update',
    'threads.form.done': 'Done',
    'threads.form.toast.alreadyConnected':
      'This Threads account is already connected. Opening detail…',
    'threads.form.toast.fetched': 'Fetched your Threads profile. Click "Done" to save.',
    'threads.form.toast.connectError': 'Could not connect to Threads. Please try again.',
    'threads.form.toast.updated': 'Threads account updated.',
    'threads.form.toast.needLogin': 'Please sign in with Threads first.',
    'threads.form.toast.saved': 'Threads account saved.',
    'threads.form.toast.updateError': 'Could not update the Threads account.',
    'threads.form.toast.saveError': 'Could not save the Threads account.',
    'threads.form.oauth.accessDenied': 'You denied access to the app (access_denied).',
    'threads.form.oauth.invalidRequest': 'Invalid OAuth request. Please try again.',
    'threads.form.oauth.serverError': 'Threads is temporarily unavailable. Please try again.',
    'threads.form.oauth.rejected': 'Threads rejected the request: {description}',
    'threads.form.oauth.error': 'Threads returned an error: {error}',
    'threads.form.oauth.stateMismatch':
      'OAuth state mismatch. Please sign in again (CSRF protection).',

    'threads.detail.stat.followers': 'Followers',
    'threads.detail.stat.synced': 'Synced',
    'threads.detail.stat.userId': 'User ID',
    'threads.detail.btn.sync': 'Sync from Threads',
    'threads.detail.btn.viewAll': 'View all posts',
    'threads.detail.btn.disconnect': 'Disconnect',
    'threads.detail.syncedAgo': 'Synced {ago}',
    'threads.detail.posts.title': 'Posts on Threads',
    'threads.detail.posts.subtitle': 'Fetched via /me/threads with the threads_basic scope',
    'threads.detail.empty.title': 'No posts synced yet',
    'threads.detail.empty.desc': 'Click "Sync from Threads" to fetch this account\'s posts.',
    'threads.detail.toast.synced': 'Synced {n} posts from Threads.',
    'threads.detail.toast.syncError': 'Sync failed.',

    'threads.postsPage.filter.all': 'All',
    'threads.postsPage.filter.text': 'Text',
    'threads.postsPage.filter.image': 'Image',
    'threads.postsPage.filter.video': 'Video',
    'threads.postsPage.filter.carousel': 'Carousel',
    'threads.postsPage.empty.title': 'No posts yet',
    'threads.postsPage.empty.descFiltered':
      'No posts match this filter. Try another filter or click "Sync" to fetch new data.',
    'threads.postsPage.empty.descDefault': 'Click "Sync" to fetch the latest posts from Threads.',
    'threads.postsPage.followers': 'followers',
    'threads.postsPage.postsSynced': 'posts synced',
    'threads.postsPage.toast.synced': 'Synced the latest {n} posts from Threads.',
    'threads.postsPage.toast.syncError': 'Failed to sync posts.',

    'threadsPost.list.title': 'Threads Posts',
    'threadsPost.list.create': 'Create post',
    'threadsPost.list.searchLabel': 'Search',
    'threadsPost.list.searchPlaceholder': 'Search by content',
    'threadsPost.list.accountLabel': 'Account',
    'threadsPost.list.allAccounts': 'All accounts',
    'threadsPost.list.statusLabel': 'Status',
    'threadsPost.list.apply': 'Filter',
    'threadsPost.list.reset': 'Reset',
    'threadsPost.status.all': 'All statuses',
    'threadsPost.status.allShort': 'All',
    'threadsPost.status.draft': 'Draft',
    'threadsPost.status.scheduled': 'Scheduled',
    'threadsPost.status.published': 'Published',
    'threadsPost.status.failed': 'Failed',

    'threadsPost.table.badge.published': 'Published',
    'threadsPost.table.badge.failed': 'Failed',
    'threadsPost.table.badge.scheduled': '📅 Scheduled',
    'threadsPost.table.badge.processing': '⏳ Publishing',
    'threadsPost.table.badge.draft': 'Draft',
    'threadsPost.table.media.text': 'Text',
    'threadsPost.table.media.items': '{n} items',
    'threadsPost.table.time.waitingCron': 'Waiting for cron',
    'threadsPost.table.time.publishing': 'Publishing…',
    'threadsPost.table.col.account': 'Account',
    'threadsPost.table.col.content': 'Content',
    'threadsPost.table.col.media': 'Media',
    'threadsPost.table.col.status': 'Status',
    'threadsPost.table.col.time': 'Time',
    'threadsPost.table.col.link': 'Post link',
    'threadsPost.table.col.createdAt': 'Created',
    'threadsPost.table.col.actions': 'Actions',
    'threadsPost.table.reschedule.title': 'Reschedule',
    'threadsPost.table.reschedule.minLead': 'At least {min} minutes from now.',
    'threadsPost.table.reschedule.placeholder': 'Pick a new date & time',
    'threadsPost.table.reschedule.save': 'Save schedule',
    'threadsPost.table.reschedule.invalid': 'Please pick a time.',
    'threadsPost.table.reschedule.tooSoon': 'Publish time must be at least {min} minutes from now.',
    'threadsPost.table.delete.title': 'Delete post?',
    'threadsPost.table.delete.desc':
      'The post will be removed from our system. A post already published on Threads stays live.',
    'threadsPost.table.delete.confirm': 'Delete',
    'threadsPost.table.toast.deleted': 'Post deleted.',
    'threadsPost.table.publishNow.title': 'Publish the scheduled post now?',
    'threadsPost.table.publishNow.desc':
      'The automatic schedule will be cancelled and the post will publish immediately.',
    'threadsPost.table.publishNow.confirm': 'Publish now',
    'threadsPost.table.toast.published': 'Post published.',
    'threadsPost.table.toast.publishError': 'Failed to publish.',
    'threadsPost.table.toast.retried': 'Retried publishing.',
    'threadsPost.table.toast.retryError': 'Retry failed.',
    'threadsPost.table.toast.rescheduled': 'Schedule updated.',
    'threadsPost.table.toast.rescheduleError': 'Failed to update schedule.',
    'threadsPost.table.cancelSchedule.title': 'Cancel schedule?',
    'threadsPost.table.cancelSchedule.desc': 'The post will revert to Draft.',
    'threadsPost.table.cancelSchedule.confirm': 'Cancel schedule',
    'threadsPost.table.toast.scheduleCancelled': 'Schedule cancelled.',
    'threadsPost.table.empty.title': 'No posts yet',
    'threadsPost.table.empty.desc': 'Create your first post to publish to Threads',
    'threadsPost.table.tooltip.viewOnThreads': 'View on Threads',
    'threadsPost.table.tooltip.reschedule': 'Reschedule',
    'threadsPost.table.tooltip.cancelSchedule': 'Cancel schedule',
    'threadsPost.table.tooltip.retry': 'Retry publishing',
    'threadsPost.table.tooltip.publishNow': 'Publish now',
    'threadsPost.table.tooltip.edit': 'Edit post',
    'threadsPost.table.tooltip.delete': 'Delete post',
    'threadsPost.table.copyLink': 'Copy link',

    'threadsPost.form.title.create': 'Create Threads post',
    'threadsPost.form.title.edit': 'Edit Threads post',
    'threadsPost.form.subtitle': 'Compose content, attach images/videos, and publish to Threads.',
    'threadsPost.form.badge.published': '✓ Published',
    'threadsPost.form.badge.failed': '⚠ Failed',
    'threadsPost.form.badge.scheduled': '📅 Scheduled',
    'threadsPost.form.badge.processing': '⏳ Publishing',
    'threadsPost.form.badge.draft': '• Draft',
    'threadsPost.form.step1.title': 'Which account to post from?',
    'threadsPost.form.step1.hint': 'Choose a connected Threads account',
    'threadsPost.form.field.account': 'Threads account',
    'threadsPost.form.field.accountPlaceholder': 'Select an account',
    'threadsPost.form.field.noAccounts': 'No active Threads accounts yet',
    'threadsPost.form.step2.title': 'Compose content',
    'threadsPost.form.step2.hint': 'Up to {max} characters',
    'threadsPost.form.message.placeholder': "What's on your mind?",
    'threadsPost.form.step3.title': 'Image / Video (optional)',
    'threadsPost.form.step3.hint': 'Up to {max} items. Images ≤ 8MB, videos ≤ 1GB.',
    'threadsPost.form.addImage': 'Add image',
    'threadsPost.form.addVideo': 'Add video',
    'threadsPost.form.uploading': 'Uploading…',
    'threadsPost.form.carouselTag': 'Carousel — {n} items',
    'threadsPost.form.noMedia': 'No media. You can post text only.',
    'threadsPost.form.removeMedia': 'Remove media',
    'threadsPost.form.step4.title': 'Publishing mode',
    'threadsPost.form.step4.hint': 'Save draft, auto-schedule, or publish now',
    'threadsPost.form.mode.draft.label': 'Save draft',
    'threadsPost.form.mode.draft.hint': 'Save to edit and publish later.',
    'threadsPost.form.mode.schedule.label': 'Schedule',
    'threadsPost.form.mode.schedule.hint': 'Auto-publish at a chosen time.',
    'threadsPost.form.mode.publish.label': 'Publish now',
    'threadsPost.form.mode.publish.hint': 'Send the post to Threads immediately.',
    'threadsPost.form.schedule.timeLabel': 'Publish time',
    'threadsPost.form.schedule.placeholder': 'Pick a date and time',
    'threadsPost.form.schedule.tz': 'Timezone: {tz}. At least {min} minutes from now.',
    'threadsPost.form.schedule.willPost': '⏰ Will publish',
    'threadsPost.form.preview.label': 'Preview',
    'threadsPost.form.preview.namePlaceholder': 'Display name',
    'threadsPost.form.preview.contentPlaceholder': 'Your post content will appear here…',
    'threadsPost.form.preview.like': '❤ Like',
    'threadsPost.form.preview.reply': '💬 Reply',
    'threadsPost.form.preview.repost': '🔁 Repost',
    'threadsPost.form.preview.share': '↗ Share',
    'threadsPost.form.footer.schedule': 'The system will auto-publish at the time you chose.',
    'threadsPost.form.footer.publish': 'The post will publish to Threads as soon as you click.',
    'threadsPost.form.footer.draft': 'Drafts can be edited, scheduled, or published anytime.',
    'threadsPost.form.submit.editSchedule': 'Update schedule',
    'threadsPost.form.submit.editSave': 'Save changes',
    'threadsPost.form.submit.schedule': '📅 Schedule',
    'threadsPost.form.submit.publish': '🚀 Publish now',
    'threadsPost.form.submit.draft': 'Save draft',
    'threadsPost.form.cancel': 'Cancel',
    'threadsPost.form.toast.maxItems': 'Up to {max} items per post.',
    'threadsPost.form.toast.imageUploadError': 'Image upload failed.',
    'threadsPost.form.toast.videoUploadError': 'Video upload failed.',
    'threadsPost.form.validate.account': 'Please select a Threads account.',
    'threadsPost.form.validate.content': 'A post needs content or at least one media item.',
    'threadsPost.form.validate.overLimit': 'Content exceeds {max} characters.',
    'threadsPost.form.validate.scheduleTime': 'Please choose a publish time.',
    'threadsPost.form.validate.scheduleTooSoon':
      'Publish time must be at least {min} minutes from now.',
    'threadsPost.form.toast.publishedNow': 'Post published!',
    'threadsPost.form.toast.sent': 'Sent.',
    'threadsPost.form.toast.scheduled': 'Scheduled to publish at {time}.',
    'threadsPost.form.toast.draftSaved': 'Draft saved.',
    'threadsPost.form.toast.editScheduleUpdated': 'Schedule updated.',
    'threadsPost.form.toast.editSaved': 'Changes saved.',
    'threadsPost.form.toast.editError': 'Save failed.',
    'threadsPost.form.toast.createError': 'Failed to create the post.',

    // ===== Admin · Instagram (bilingual) =====
    'instagram.common.search': 'Search',
    'instagram.common.reset': 'Reset',
    'instagram.common.cancel': 'Cancel',
    'instagram.common.back': 'Back to list',
    'instagram.common.open': 'Open',
    'instagram.common.active': 'Active',
    'instagram.common.disabled': 'Disabled',
    'instagram.common.accountNotFound': 'Account not found.',
    'instagram.common.noCaption': '(No caption)',
    'instagram.common.loading': 'Loading…',

    'instagram.list.title': 'Instagram accounts',
    'instagram.list.add': 'Add',
    'instagram.list.searchLabel': 'Search account',
    'instagram.list.searchPlaceholder': 'Enter name or username…',

    'instagram.account.table.col.account': 'Account name',
    'instagram.account.table.col.username': 'Username',
    'instagram.account.table.col.userId': 'User ID',
    'instagram.account.table.col.status': 'Status',
    'instagram.account.table.col.createdAt': 'Created',
    'instagram.account.table.col.actions': 'Actions',
    'instagram.account.table.empty.title': 'No data yet',
    'instagram.account.table.empty.desc': 'Add your first record to get started',
    'instagram.account.table.tooltip.viewDetail': 'View account detail',
    'instagram.account.table.tooltip.edit': 'Edit account',
    'instagram.account.table.tooltip.disconnect': 'Disconnect (revoke Instagram access)',
    'instagram.account.table.toast.statusChanged': 'Account status updated',
    'instagram.account.table.toast.statusError': 'Failed to update account status',
    'instagram.account.table.toast.copied': 'User id copied.',

    'instagram.disconnect.title': 'Disconnect Instagram account?',
    'instagram.disconnect.desc':
      'The system will delete the stored access token and metadata for this account. The app will no longer have Instagram access on Meta. You can reconnect anytime via the "Add" button.',
    'instagram.disconnect.confirm': 'Disconnect',
    'instagram.disconnect.toast.success': 'Instagram account disconnected.',
    'instagram.disconnect.toast.error': 'Could not disconnect.',

    'instagram.form.title.create': 'Connect Instagram account',
    'instagram.form.title.update': 'Update Instagram account',
    'instagram.form.signIn': 'Sign in with Instagram',
    'instagram.form.signInAgain': 'Sign in with Instagram again',
    'instagram.form.fetchedChip': 'Profile fetched from Instagram',
    'instagram.form.field.name': 'Name',
    'instagram.form.field.username': 'Username',
    'instagram.form.field.userId': 'User ID',
    'instagram.form.field.active': 'Active',
    'instagram.form.create': 'Create',
    'instagram.form.update': 'Update',
    'instagram.form.toast.missingClientId': 'Missing REACT_APP_INSTAGRAM_CLIENT_ID configuration.',
    'instagram.form.toast.userDenied':
      'You declined the permission request. The app needs {scopes} to publish to Instagram.',
    'instagram.form.toast.rejected': 'Instagram rejected the sign-in: {description}',
    'instagram.form.toast.stateMismatch': 'Invalid OAuth state, please sign in again.',
    'instagram.form.toast.fetchError': 'Failed to fetch Instagram profile',
    'instagram.form.toast.needLogin':
      'You need to sign in with Instagram before creating the account.',
    'instagram.form.toast.created': 'Account created successfully.',
    'instagram.form.toast.createError': 'Failed to create the account.',
    'instagram.form.toast.updated': 'Account updated successfully.',
    'instagram.form.toast.updateError': 'Failed to update the account.',
    'instagram.form.toast.alreadyConnected':
      'This Instagram account is already connected. Opening detail…',
    'instagram.form.oauth.accessDenied':
      'You cancelled the permission request on the Instagram consent screen. The app needs instagram_business_basic and instagram_business_content_publish to connect your account.',
    'instagram.form.oauth.invalidRequest':
      'The OAuth request was invalid (wrong redirect URI or app configuration). Please try again.',
    'instagram.form.oauth.serverError':
      'Instagram returned a server error during sign-in. Please try again in a few minutes.',
    'instagram.form.oauth.rejected': 'Instagram rejected the sign-in: {description}',
    'instagram.form.oauth.error': 'Instagram sign-in failed: {error}',

    'instagram.detail.stat.followers': 'Followers',
    'instagram.detail.stat.posts': 'Posts',
    'instagram.detail.stat.userId': 'User ID',
    'instagram.detail.accountType': 'Account type',
    'instagram.detail.btn.sync': 'Sync from Instagram',
    'instagram.detail.btn.disconnect': 'Disconnect',
    'instagram.detail.openProfile': 'Open Instagram profile',
    'instagram.detail.posts.title': 'Posts on Instagram',
    'instagram.detail.posts.subtitle':
      'Fetched via the /me/media API with the instagram_business_basic permission',
    'instagram.detail.empty.title': 'No posts yet',
    'instagram.detail.empty.desc':
      'Click "Sync from Instagram" to fetch the latest posts for this account.',
    'instagram.detail.toast.synced': 'Synced profile and posts from Instagram.',
    'instagram.detail.toast.syncError':
      'Sync failed. The token may have expired — please reconnect.',

    'instagram.post.list.title': 'Instagram posts',
    'instagram.post.list.create': 'Create post',
    'instagram.post.list.searchLabel': 'Search',
    'instagram.post.list.searchPlaceholder': 'Search by caption',
    'instagram.post.list.accountLabel': 'Account',
    'instagram.post.list.allAccounts': 'All accounts',
    'instagram.post.list.statusLabel': 'Status',
    'instagram.post.list.apply': 'Filter',
    'instagram.post.list.reset': 'Reset',
    'instagram.post.status.all': 'All statuses',
    'instagram.post.status.allShort': 'All',
    'instagram.post.status.draft': 'Draft',
    'instagram.post.status.scheduled': 'Scheduled',
    'instagram.post.status.published': 'Published',
    'instagram.post.status.failed': 'Failed',

    'instagram.post.table.col.account': 'Account',
    'instagram.post.table.col.media': 'Media',
    'instagram.post.table.col.caption': 'Caption',
    'instagram.post.table.col.status': 'Status',
    'instagram.post.table.col.time': 'Time',
    'instagram.post.table.col.link': 'Post link',
    'instagram.post.table.col.createdAt': 'Created',
    'instagram.post.table.col.actions': 'Actions',
    'instagram.post.table.badge.published': 'Published',
    'instagram.post.table.badge.failed': 'Failed',
    'instagram.post.table.badge.scheduled': '📅 Scheduled',
    'instagram.post.table.badge.processing': '⏳ Publishing',
    'instagram.post.table.badge.draft': 'Draft',
    'instagram.post.table.media.carousel': '📷 Carousel · {count}',
    'instagram.post.table.media.reels': '🎬 Reels',
    'instagram.post.table.media.image': '🖼 Image',
    'instagram.post.table.time.waitingCron': 'Waiting for the cron job',
    'instagram.post.table.time.processing': 'Publishing…',
    'instagram.post.table.empty.title': 'No posts yet',
    'instagram.post.table.empty.desc': 'Create your first post to publish to Instagram',
    'instagram.post.table.reschedule.title': 'Change publish time',
    'instagram.post.table.reschedule.placeholder': 'Pick a new date and time',
    'instagram.post.table.reschedule.minLead': 'At least {min} minutes from now.',
    'instagram.post.table.reschedule.save': 'Save schedule',
    'instagram.post.table.tooltip.open': 'View on Instagram',
    'instagram.post.table.copyLink': 'Copy link',
    'instagram.post.table.tooltip.reschedule': 'Change publish time',
    'instagram.post.table.tooltip.cancelSchedule': 'Cancel schedule',
    'instagram.post.table.tooltip.publishNow': 'Publish now',
    'instagram.post.table.tooltip.edit': 'Edit post',
    'instagram.post.table.tooltip.delete': 'Delete post',
    'instagram.post.table.confirm.delete.title': 'Delete post?',
    'instagram.post.table.confirm.delete.desc':
      'The post will be removed from the system. The post already published on Instagram remains.',
    'instagram.post.table.confirm.delete.confirm': 'Delete',
    'instagram.post.table.confirm.publish.title': 'Publish the scheduled post now?',
    'instagram.post.table.confirm.publish.desc':
      'The auto-schedule will be cancelled and the post will be published immediately.',
    'instagram.post.table.confirm.publish.confirm': 'Publish now',
    'instagram.post.table.confirm.cancel.title': 'Cancel schedule?',
    'instagram.post.table.confirm.cancel.desc':
      'The post will return to Draft and will no longer auto-publish.',
    'instagram.post.table.confirm.cancel.confirm': 'Cancel schedule',
    'instagram.post.table.toast.deleted': 'Post deleted.',
    'instagram.post.table.toast.published': 'Post published.',
    'instagram.post.table.toast.publishError': 'Failed to publish.',
    'instagram.post.table.toast.rescheduled': 'Schedule updated.',
    'instagram.post.table.toast.rescheduleError': 'Failed to update the schedule.',
    'instagram.post.table.toast.cancelled': 'Schedule cancelled.',
    'instagram.post.table.toast.cancelError': 'Failed to cancel the schedule.',
    'instagram.post.table.validate.pickTime': 'Please choose a time.',
    'instagram.post.table.validate.tooSoon':
      'The publish time must be at least {min} minutes from now.',

    'instagram.post.form.title.create': 'Create Instagram post',
    'instagram.post.form.title.edit': 'Edit Instagram post',
    'instagram.post.form.subtitle':
      'Choose an account, upload media, write a caption. Save as draft, schedule, or publish now.',
    'instagram.post.form.badge.published': '✓ Published',
    'instagram.post.form.badge.failed': '⚠ Failed',
    'instagram.post.form.badge.scheduled': '📅 Scheduled',
    'instagram.post.form.badge.processing': '⏳ Publishing',
    'instagram.post.form.badge.draft': '• Draft',
    'instagram.post.form.step1.title': 'Which account to post from?',
    'instagram.post.form.step1.hint': 'Choose a connected Instagram Business account',
    'instagram.post.form.field.account': 'Instagram account',
    'instagram.post.form.field.accountPlaceholder': 'Select an account',
    'instagram.post.form.field.noAccounts': 'No Instagram accounts yet',
    'instagram.post.form.step2.title': 'Post type',
    'instagram.post.form.step2.hint': 'Choose the right content type',
    'instagram.post.form.media.image.label': 'Single image',
    'instagram.post.form.media.image.hint': '1 image posted to the feed',
    'instagram.post.form.media.carousel.label': 'Carousel',
    'instagram.post.form.media.carousel.hint': '2-10 images, swipe through each',
    'instagram.post.form.media.reels.label': 'Reels',
    'instagram.post.form.media.reels.hint': '1 vertical video, posted as Reels',
    'instagram.post.form.step3.title': 'Media',
    'instagram.post.form.step3.hint.image': 'Upload 1 image (jpg/png/webp)',
    'instagram.post.form.step3.hint.carousel': 'Upload 2-{max} images, drag to reorder',
    'instagram.post.form.step3.hint.reels': 'Upload 1 mp4 video (Reels)',
    'instagram.post.form.addImage': 'Add image',
    'instagram.post.form.addVideo': 'Add video',
    'instagram.post.form.carouselCount': 'Uploaded: {n}/{max} images',
    'instagram.post.form.removeMedia': 'Remove media',
    'instagram.post.form.confirmChangeType':
      'Changing the media type will remove uploaded media. Continue?',
    'instagram.post.form.step4.title': 'Caption',
    'instagram.post.form.step4.hint': 'Up to {max} characters',
    'instagram.post.form.caption.placeholder': 'Caption, description, hashtags…',
    'instagram.post.form.step5.title': 'Publishing mode',
    'instagram.post.form.step5.hint': 'Save draft, auto-schedule, or publish now',
    'instagram.post.form.mode.draft.label': 'Save draft',
    'instagram.post.form.mode.draft.hint': 'Save to edit and publish later.',
    'instagram.post.form.mode.schedule.label': 'Schedule',
    'instagram.post.form.mode.schedule.hint': 'Auto-publish at a chosen date and time.',
    'instagram.post.form.mode.publish.label': 'Publish now',
    'instagram.post.form.mode.publish.hint': 'Send to Instagram immediately.',
    'instagram.post.form.schedule.timeLabel': 'Publish time',
    'instagram.post.form.schedule.placeholder': 'Pick a date and time',
    'instagram.post.form.schedule.tz': 'Timezone: {tz}. At least {min} minutes from now.',
    'instagram.post.form.schedule.willPost': '⏰ Will publish',
    'instagram.post.form.preview.label': 'Preview',
    'instagram.post.form.preview.account': 'Account',
    'instagram.post.form.preview.now': 'Now',
    'instagram.post.form.preview.noMedia': 'No media yet',
    'instagram.post.form.preview.captionPlaceholder': 'Your caption will appear here…',
    'instagram.post.form.footer.schedule': 'The system will auto-publish at the time you chose.',
    'instagram.post.form.footer.publish':
      'The post will be sent to Instagram as soon as you click.',
    'instagram.post.form.footer.draft': 'Drafts can be edited, scheduled, or published anytime.',
    'instagram.post.form.submit.editSchedule': 'Update schedule',
    'instagram.post.form.submit.editSave': 'Save changes',
    'instagram.post.form.submit.schedule': '📅 Schedule',
    'instagram.post.form.submit.publish': '🚀 Publish now',
    'instagram.post.form.submit.draft': 'Save draft',
    'instagram.post.form.cancel': 'Cancel',
    'instagram.post.form.validate.account': 'Please select an Instagram account.',
    'instagram.post.form.validate.media': 'Please add media.',
    'instagram.post.form.validate.imageOne': 'A single image needs exactly 1 image.',
    'instagram.post.form.validate.carouselRange': 'Carousel needs 2-{max} images.',
    'instagram.post.form.validate.reelsOne': 'Reels needs exactly 1 video.',
    'instagram.post.form.validate.captionLimit': 'Caption can be at most {max} characters.',
    'instagram.post.form.validate.scheduleTime': 'Please choose a publish time.',
    'instagram.post.form.validate.scheduleTooSoon':
      'The publish time must be at least {min} minutes from now.',
    'instagram.post.form.toast.imageOnlyOne': 'A single image accepts only 1 file.',
    'instagram.post.form.toast.carouselMax': 'Carousel allows at most {max} images.',
    'instagram.post.form.toast.imageUploadError': 'Image upload failed.',
    'instagram.post.form.toast.videoUploadError': 'Video upload failed.',
    'instagram.post.form.toast.publishedNow': 'Post published!',
    'instagram.post.form.toast.sent': 'Sent.',
    'instagram.post.form.toast.scheduled': 'Scheduled to publish at {time}.',
    'instagram.post.form.toast.draftSaved': 'Draft saved.',
    'instagram.post.form.toast.editScheduleUpdated': 'Schedule updated.',
    'instagram.post.form.toast.editSaved': 'Changes saved.',
    'instagram.post.form.toast.editError': 'Save failed.',
    'instagram.post.form.toast.createError': 'Failed to create the post.',

    // ===== Admin · Dashboard (/admin home) =====
    'admin.dash.greeting.morning': 'Good morning',
    'admin.dash.greeting.noon': 'Good afternoon',
    'admin.dash.greeting.afternoon': 'Good afternoon',
    'admin.dash.greeting.evening': 'Good evening',

    'admin.dash.health.attention': 'Needs attention',
    'admin.dash.health.warning': 'Has warnings',
    'admin.dash.health.stable': 'Running smoothly',

    'admin.dash.status.draft': 'Draft',
    'admin.dash.status.scheduled': 'Scheduled',
    'admin.dash.status.processing': 'Processing',
    'admin.dash.status.published': 'Published',
    'admin.dash.status.failed': 'Failed',

    'admin.dash.header.summary': '{accounts} accounts · {posts} posts',
    'admin.dash.header.refresh': 'Refresh',
    'admin.dash.header.export': 'Export Excel',
    'admin.dash.header.exporting': 'Exporting',
    'admin.dash.toast.exportSuccess': 'Report exported successfully',
    'admin.dash.toast.exportError': 'Could not export the report. Please try again.',
    'admin.dash.error.title': 'Failed to load statistics.',
    'admin.dash.error.hint': 'Check the API connection or sign in again.',

    'admin.dash.kpi.posted24h': 'Posted (24h)',
    'admin.dash.kpi.vsYesterday': 'vs yesterday',
    'admin.dash.kpi.successRate7d': 'Success rate (7d)',
    'admin.dash.kpi.successSub': '{posted} posted / {failed} failed',
    'admin.dash.kpi.scheduledNext24h': 'Scheduled (next 24h)',
    'admin.dash.kpi.failed24h': 'Failed (24h)',
    'admin.dash.kpi.needReview': 'Needs review',
    'admin.dash.kpi.none': 'None',
    'admin.dash.kpi.tokenExpiring': 'Tokens < 7 days',
    'admin.dash.kpi.needReconnect': 'Reconnect needed',
    'admin.dash.kpi.safe': 'Safe',

    'admin.dash.trend.title': '14-day posting trend',
    'admin.dash.trend.subtitle': 'Successful posts by platform',
    'admin.dash.trend.total14d': '14-day total',
    'admin.dash.trend.empty': 'No posting data in the last 14 days',

    'admin.dash.platform.title': 'Distribution by platform',
    'admin.dash.platform.subtitle': 'Post count — click a row to open the list',
    'admin.dash.platform.totalLabel': 'Total posts',
    'admin.dash.platform.tooltipSuffix': 'posts',
    'admin.dash.platform.empty': 'No posts yet',

    'admin.dash.statusChart.title': 'Post status',
    'admin.dash.statusChart.subtitle': 'Distribution by processing status',
    'admin.dash.statusChart.totalLabel': 'Total',
    'admin.dash.statusChart.empty': 'No posts',

    'admin.dash.tokens.title': 'Tokens expiring soon',
    'admin.dash.tokens.range': 'Next 14 days',
    'admin.dash.tokens.empty': 'No tokens expiring soon',
    'admin.dash.tokens.daysLeft': '{days} days left',
    'admin.dash.tokens.view': 'View',

    'admin.dash.schedules.title': 'Upcoming schedule',
    'admin.dash.schedules.range': 'Next 7 days',
    'admin.dash.schedules.empty': 'No posts scheduled in the next 7 days',

    'admin.dash.activity.title': 'Recent activity',
    'admin.dash.activity.failedCount': '{count} failed',
    'admin.dash.activity.empty': 'No recent posting activity',
  },
};

// Merge admin-area fragments so every feature key resolves through the same `t()`.
Object.assign(dictionary.vi, adminDictionary.vi);
Object.assign(dictionary.en, adminDictionary.en);

export default dictionary;
